var bodyScrollLockOptions = {
  reserveScrollBarGap: true,
};

// Define a global function to load a script
window.loadScript = function (url) {
  // Check if the script already exists
  var existingScript = document.querySelector(`script[src="${url}"]`);

  if (existingScript) {
    return;
  }

  // Create a new script element
  var script = document.createElement("script");
  script.src = url;
  document.body.appendChild(script);
};

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, {
        capture: true,
        passive: isScrollEvent,
      });
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, {
        capture: false,
        passive: isScrollEvent,
      });
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return (
    ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
      eventType
    ) !== -1
  );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  const isScrollEvent =
    ["wheel", "mousewheel", "touchstart", "touchmove"].indexOf(eventType) !==
    -1;

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, {
        capture: useCapture,
        passive: isScrollEvent,
      });
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if (
      (!selector || selector === listener.selector) &&
      (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
        target.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          target.tagName.toLowerCase()
        ) > -1 &&
        target.hasAttribute("disabled")
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
      // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document ||
      // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement ||
      // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

class Popup {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="open-modal"]',
      this.openModal.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-modal"]',
      this.closeModal.bind(this)
    );
    document.addEventListener(
      "posted_successfully",
      this.openModalSpecial.bind(this)
    );

    this.onClickOutsideListener = this.closeModal.bind(this);
  }

  openModal() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(
      event.target.getAttribute("aria-controls")
    );
    this.activeModal.setAttribute("aria-hidden", "false");
    this.activeModal.style.display = "block";
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    var focus = this.element.querySelector("[data-scrollable]");

    setTimeout(() => {
      trapFocus(this.activeModal);
    }, 100);
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
  }
  openModalSpecial() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(event.detail.id);
    this.activeModal.setAttribute("aria-hidden", "false");
    var focus = this.element.querySelector("[data-scrollable]");
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    trapFocus(this.activeModal);
  }
  closeModal() {
    this.activeModal = document.body.querySelector(
      '.Popup[aria-hidden="false"]'
    );
    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener(
      "click",
      this.onClickOutsideListener
    );
    this.activeModal.setAttribute("aria-hidden", "true");

    bodyScrollLock.clearAllBodyScrollLocks();
    this.activeModal.removeAttribute("style");
  }
}

class RevolutionImageZoom {
  constructor(element, slideshow) {
    this.element = element;
    this.slideshow = slideshow;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    loadScript(window.theme.pswpScript);
    this.syncHeight();
    this.bindEvents();
  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--window-inner-height",
      `${window.innerHeight}px`
    );
  }

  bindEvents() {
    window.addEventListener("resize", this.syncHeight());
    this.delegateElement.on(
      "click",
      '[data-action="open-product-zoom"]',
      this.initPhotoSwipe.bind(this)
    );
    this.delegateElement.on(
      "click",
      ".ProductSliderCell--Zoom",
      this.initPhotoSwipeFromImageClick.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoswiperClose.bind(this)
    );
  }
  photoswiperClose() {
    this.photoSwipeInstance.close;
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove("pswp-open-in-ios");
    }
  }

  initPhotoSwipe() {
    var images = [],
      index = 0;
    if (this.slideshow) {
      this.slideshow.swiperElement.slides.forEach(function (item) {
        if (item.classList.contains("ProductSliderCell--Zoom")) {
          if (item.querySelector("img")) {
            images.push(item.querySelector("img"));
          }
        }
      });
      var index_currentSlide = this.slideshow.swiperElement.realIndex;
      this.slideshow.swiperElement.slides[index_currentSlide]
        .querySelector(".ProductSlider--Element")
        .getAttribute("data-image-position");
    } else {
      images.push(document.querySelector(".ProductSlider--Image"));
    }

    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      parseInt(index)
    );
  }

  initPhotoSwipeFromImageClick(event, target) {
    // Check if the current breakpoint is "pocket". If it is, return without doing anything.
    if (new Responsive().matchesBreakpoint("pocket")) {
      return;
    }

    // Create an array of images from the siblings of the target element.
    const images = [];
    const siblings = Array.from(target.parentElement.children);

    siblings.forEach((item) => {
      if (
        item.classList.contains("ProductSliderCell--Zoom") &&
        item.querySelector("img")
      ) {
        images.push(item.querySelector("img"));
      }
    });

    // Get the image position from the target element's data attribute.
    const imagePosition = parseInt(
      target
        .querySelector(".ProductSlider--Element")
        .getAttribute("data-image-position")
    );

    // Create the PhotoSwipe instance using the images and image position.
    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      imagePosition
    );
  }

  createPhotoSwipeItemsFromImages(images) {
    return images.map(function (image) {
      var maxWidth = parseInt(image.getAttribute("data-max-width")),
        maxHeight = parseInt(image.getAttribute("data-max-height")),
        maxDimension = new Responsive().matchesBreakpoint("phone")
          ? 1200
          : 2200,
        reduceFactor = 1.0;

      if (maxWidth >= maxHeight) {
        reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
      } else {
        reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
      }
      var requestedWidth = Math.floor(maxWidth / reduceFactor);
      var requestedHeight = Math.floor(maxHeight / reduceFactor);
      return {
        msrc: image.currentSrc || image.src,
        w: requestedWidth,
        h: requestedHeight,
        initialZoomLevel: 0.65,
        src: image.dataset.originalSrc,
      };
    });
  }

  createPhotoSwipeInstance(items, selectedImageIndex) {
    var _this = this;
    var photoswipeContainer = document.querySelector(".pswp");
    this.photoSwipeInstance = new PhotoSwipe(
      photoswipeContainer,
      false,
      items,
      {
        index: selectedImageIndex,
        showHideOpacity: true,
        showAnimationDuration: 500,
        loop: false,
        history: false,
        closeOnVerticalDrag: true,
        allowPanToNext: false,
        pinchToClose: false,
        errorMsg: '<p class="pswp__error-msg"></p>',
        scaleMode: "orig",
        getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
          if (isMouseClick) {
            return 1.35;
          } else {
            return item.initialZoomLevel < 0.7 ? 1 : 1.33;
          }
        },
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var allThumbnail = _this.element.querySelectorAll(
              ".mainSwiper .ProductSliderCell--Zoom img"
            ),
            thumbnail = allThumbnail[index],
            pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },
      }
    );

    this.photoSwipeInstance.listen(
      "beforeChange",
      this.onslideChanged.bind(this)
    );
    this.photoSwipeInstance.listen(
      "destroy",
      this.destroyPhotoSwipe.bind(this)
    );
    this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
    this.photoSwipeInstance.listen(
      "initialZoomIn",
      this.onInitialZoomIn.bind(this)
    );
    this.photoSwipeInstance.listen(
      "initialZoomOut",
      this.onInitialZoomOut.bind(this)
    );

    this.delegateRoot.on(
      "pswpTap",
      ".pswp__scroll-wrap",
      this.onSingleTap.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoSwipeInstance.close
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--prev",
      this.photoSwipeInstance.prev
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--next",
      this.photoSwipeInstance.next
    );
    this.photoSwipeInstance.listen("close", this.photoswiperClose.bind(this));
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.add("pswp-open-in-ios");
    }
    this.photoSwipeInstance.init();
  }

  onslideChanged() {
    if (this.photoSwipeInstance.getCurrentIndex() === 0) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .removeAttribute("disabled");
    }

    if (
      this.photoSwipeInstance.getCurrentIndex() + 1 ===
      this.photoSwipeInstance.options.getNumItemsFn()
    ) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .removeAttribute("disabled");
    }
  }

  onSingleTap(event) {
    if (!event.detail || event.detail.pointerType === "mouse") {
      if (event.target.classList.contains("pswp__img")) {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    } else {
      if (event.target.classList.contains("pswp__button")) {
        return;
      }

      event.target
        .closest(".pswp")
        .querySelector(".pswp__ui")
        .classList.toggle("pswp__ui--hidden");
    }
  }

  onDoubleTap(point) {
    var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(
        initialZoomLevel < 0.7 ? 1 : 1.33,
        point,
        333
      );
    }
  }

  onInitialZoomIn() {
    document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");
  }
  onInitialZoomOut() {
    document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
  }
  destroyPhotoSwipe() {
    this.delegateRoot.off("pswpTap");
    this.photoSwipeInstance = null;
  }
}

class RevolutionSelectbox {
  constructor(element, popover, additionalOverlay) {
    this.element = element;
    this.popover = popover;
    this.changeOverlay = additionalOverlay;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.dropdown = this.element.querySelector(".RevolutionSelectbox");
    this.isOpen = false;
    this.mainDropdown = this.element.querySelector(
      ".RevolutionSelectbox--Content"
    );

    this.mainDropdownContent = this.element.querySelector(
      ".RevolutionSelectbox--InnerContent"
    );
    this.mainButton = this.element.querySelector(
      ".RevolutionSelectbox--Button"
    );

    this.connectedSelect = this.element.getAttribute("data-select");
    this.selectbox = this.element.querySelector(
      "[name=" + this.connectedSelect + "]"
    );
    if (this.selectbox == null) {
      this.selectbox = this.element.querySelector(
        "[name2=" + this.connectedSelect + "]"
      );
    }
    if (this.popover == true) {
      this.mainDropdown.classList.remove("RevolutionSelectbox--animation");
      this.mainDropdown.classList.add("PopoverContent");
      if (this.changeOverlay) {
        this.pageOverlayElement = document.querySelector(
          ".localizationOverlay"
        );
      } else {
        this.pageOverlayElement = document.querySelector(".pageOverlay");
      }
    }
    this.bindEvents();
    this.initSelectbox();
  }

  bindEvents() {
    this.onClickOutsideListener = this.onClickOutside.bind(this);
    this.domDelegate.on(
      "click",
      "[data-action=toggle-selectbox]",
      this.toggleDropdown.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );
    this.domDelegate.on(
      "keypress",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-change]",
      this.selectboxChange.bind(this)
    );

    this.delegateBody.on("menu:open", this.onClickOutside.bind(this));
    this.domDelegate.on("click", "body", this.onClickOutside.bind(this));
  }

  selectboxChange() {
    var value = event.target.getAttribute("data-value");
    var selectboxID = event.target.getAttribute("data-selectboxid");
    var innerContent = event.target.innerHTML;
    var selEl = this.element.querySelector("#" + selectboxID);
    if (selEl.nodeName == "SELECT") {
      selEl.value = value;
      selEl.dispatchEvent(new Event("change"));
    } else {
      selEl
        .querySelector('[value="' + value + '"]')
        .setAttribute("checked", "true");
    }
    this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
      innerContent;

    if (this.mainButton.querySelector(".u-p4")) {
      const elem = this.mainButton.querySelector(".u-p4");
      elem.classList.remove("u-p4");
      elem.classList.add("u-p3");
    }
    if (this.element.classList.contains("dropdownSelector")) {
      this.element
        .querySelector('.RevolutionSelectbox--Item[disabled="true"]')
        .removeAttribute("disabled");
      event.target.setAttribute("disabled", "true");
    }
    this.closeDropdown(this.element);
  }

  onClickOutside(event) {
    const withinBoundaries = event.composedPath().includes(this.element);
    if (
      !withinBoundaries ||
      event.target.classList.contains("FiltersDesktopWrapper")
    ) {
      this.closeDropdown(this.element);
    }
  }

  selectboxSubmit(event) {
    if (event.key != "Enter" && event.key !== undefined) {
      return;
    }
    var value = event.target.getAttribute("data-value");
    var dataName = event.target.getAttribute("data-name");
    this.selectbox.value = value;
    this.closeDropdown(this.element);
    this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
      dataName;
    this.selectbox.parentElement.submit();
  }

  initSelectbox() {
    const selectedItem = this.mainDropdown.querySelector(
        '[selected="selected"]'
      ),
      titleElement = this.element.querySelector(".RevolutionSelectbox--Title");
    if (selectedItem) {
      titleElement.innerHTML = selectedItem.getAttribute("data-name");
    }

    trapFocus(this.element);
    this.element.style.display = "block";
  }

  toggleDropdown(event, target) {
    event.preventDefault();

    if (this.isOpen) {
      this.closeDropdown(target);
    } else {
      this.openDropdown(target);
    }
  }

  openDropdown(target) {
    // Dispatch "close:search" and "menu:close" events on the element.
    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );
    this.element.dispatchEvent(
      new CustomEvent("menu:close", { bubbles: true })
    );

    // Find all siblings with class ".RevolutionSelectbox".
    const siblings = Array.from(
      target.parentElement.parentElement.children
    ).filter((item) => item.classList.contains("RevolutionSelectbox"));

    // Hide the dropdown content for all siblings.
    siblings.forEach((item) => {
      item
        .querySelector(".RevolutionSelectbox--Button")
        .setAttribute("aria-expanded", false);
      item
        .querySelector(".RevolutionSelectbox--Content")
        .setAttribute("aria-hidden", true);
      item.querySelector(".RevolutionSelectbox--Content").style.display =
        "none";
    });

    // If the dropdown is a popover, show the page overlay and disable body scrolling.
    if (this.popover) {
      this.pageOverlayElement.classList.add("is-visible");
      this.pageOverlayElement.addEventListener(
        "click",
        this.onClickOutsideListener
      );
      const focus = this.element.querySelector("[data-scrollable]");
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      document.body.classList.add("scrollLock");
      trapFocus(this.mainDropdown);
      if (
        document.querySelector("#Drawer").getAttribute("aria-expanded") ===
        "true"
      ) {
        document.querySelector(".Drawer--Wrapper").style.overflow = "visible";
      }
    }

    // Show the dropdown content for the target element and set its state to "expanded".
    const contentElement = target.parentElement.querySelector(
      ".RevolutionSelectbox--Content"
    );
    target.setAttribute("aria-expanded", "true");
    contentElement.style.display = "block";
    contentElement.style.height = `${contentElement.offsetHeight}px`;

    if (this.popover) {
      setTimeout(() => {
        contentElement.setAttribute("aria-hidden", "false");
      }, 20);
    } else {
      contentElement.setAttribute("aria-hidden", "false");
    }

    this.isOpen = true;
    window.addEventListener("click", this.onClickOutsideListener);
  }

  closeDropdown(target) {
    var closestDropdown = target.closest(".RevolutionSelectbox");
    if (closestDropdown === null) {
      var closestDropdown = target.querySelector(
        "[aria-expanded='true']"
      ).parentElement;
    }
    closestDropdown
      .querySelector(".RevolutionSelectbox--Button")
      .setAttribute("aria-expanded", false);
    closestDropdown
      .querySelector(".RevolutionSelectbox--Content")
      .setAttribute("aria-hidden", true);
    setTimeout(() => {
      closestDropdown.querySelector(
        ".RevolutionSelectbox--Content"
      ).style.display = "none";
    }, 300);

    if (this.popover == true) {
      this.pageOverlayElement.classList.remove("is-visible");
      this.pageOverlayElement.removeEventListener(
        "click",
        this.onClickOutsideListener
      );

      const menuDrawer = document.querySelector("#Drawer");
      if (menuDrawer.getAttribute("aria-expanded") == "true") {
        document.querySelector(".Drawer--Wrapper").style.overflow = "auto";
      } else {
        bodyScrollLock.clearAllBodyScrollLocks();
        document.body.classList.remove("scrollLock");
      }
    }
    this.isOpen = false;
    removeTrapFocus(this.mainDropdownContent);
    window.removeEventListener("click", this.onClickOutsideListener);
  }
}

class Form {
  constructor() {}

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf("[");

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === "" || formElement.disabled) {
        continue;
      }

      if (
        formElement.name &&
        !formElement.disabled &&
        (formElement.checked ||
          /select|textarea/i.test(formElement.nodeName) ||
          /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
            formElement.type
          ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {},
      i = 0,
      _this = this;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = _this.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}

class AddToCart {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action=add-to-cart]",
      this.addToCart.bind(this)
    );
  }

  addToCart() {
    var _this = this;
    event.preventDefault();
    var addToCartButton = event.target;
    this.pageLoader.style.width = 100 + "%";
    addToCartButton.setAttribute("disabled", "disabled");
    var formElement = event.target.closest("form");
    formElement.querySelector('[name="id"]').removeAttribute("disabled");
    var formHelper = new Form();
    const serialized = formHelper.serialize(formElement);
    fetch(window.routes.localeRootUrl + "/cart/add.js", {
      body: JSON.stringify(serialized),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        _this.element.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: serialized.id,
              quantity: serialized.quantity,
            },
          })
        );
        
        response.json().then(function (cartData) {
          const newObj = {
            id: cartData.id,
            quantity: cartData.quantity
          };

          const oldCartStateString = localStorage.getItem('oldCartState');
          let newArray;
        
          if (oldCartStateString) {
            const oldCartState = JSON.parse(oldCartStateString);
            const existingItemIndex = oldCartState.findIndex(item => item.id === newObj.id);

            if (existingItemIndex !== -1) {
              oldCartState[existingItemIndex].quantity = newObj.quantity;
              newArray = oldCartState;
            } else {
              // If the item doesn't exist, add it to the array
              newArray = [...oldCartState, newObj];
            }
          } else {
            newArray = [newObj];
          }
        
          if(localStorage.getItem('oldCartState')) {
            compareArrays(JSON.parse(localStorage.getItem('oldCartState')), newArray);
          }
          localStorage.setItem('oldCartState', JSON.stringify(newArray));
        });

        if (window.location.href.indexOf("cart") != -1) {
          location.reload();
          return;
        }
        addToCartButton.removeAttribute("disabled");
      } else {
        response.json().then(function (content) {
          if (_this.element.querySelector(".ProductForm--Error")) {
            _this.element
              .querySelector(".ProductForm--Error")
              .classList.add("visible");
            setTimeout(function () {
              _this.element
                .querySelector(".ProductForm--Error")
                .classList.remove("visible");
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          } else {
            if(document.querySelector('.u-p4.accent')) return;
            var errorMessageElement = document.createElement("span");
            errorMessageElement.className = "u-p4 accent";
            errorMessageElement.innerHTML = content["description"];
            addToCartButton.removeAttribute("disabled");
            if(addToCartButton.closest('.ProductCard--instantATC')) {
              addToCartButton.closest('.ProductCard--instantATC').insertAdjacentElement(
                "afterend",
                errorMessageElement
              );
            } else {
              addToCartButton.insertAdjacentElement(
                "afterend",
                errorMessageElement
              );
            }
            setTimeout(function () {
              errorMessageElement.remove();
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          }
        });
      }
    });
  }
}

/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add("user-is-tabbing");

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove("user-is-tabbing");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  if (first) {
    first.focus();
  } else {
    elementToFocus.focus();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class Responsive {
  constructor() {
    var _this = this;

    this.currentBreakpoint = this.getCurrentBreakpoint();

    window.addEventListener("resize", function () {
      var newBreakpoint = _this.getCurrentBreakpoint();

      if (_this.currentBreakpoint === newBreakpoint) {
        return;
      }

      document.dispatchEvent(
        new CustomEvent("breakpoint:changed", {
          detail: {
            previousBreakpoint: _this.currentBreakpoint,
            currentBreakpoint: newBreakpoint,
          },
        })
      );

      _this.currentBreakpoint = newBreakpoint;
    });
  }

  matchesBreakpoint(breakpoint) {
    switch (breakpoint) {
      case "phone":
        return window.matchMedia("screen and (max-width: 640px)").matches;

      case "tablet":
        return window.matchMedia(
          "screen and (min-width: 641px) and (max-width: 1024px)"
        ).matches;

      case "tablet-and-up":
        return window.matchMedia("screen and (min-width: 768px)").matches;

      case "pocket":
        return window.matchMedia("screen and (max-width: 1024px)").matches;

      case "lap-and-up":
        return window.matchMedia("screen and (min-width: 1025px)").matches;

      case "desk":
        return window.matchMedia("screen and (min-width: 1280px)").matches;
    }
  }
  getCurrentBreakpoint() {
    if (window.matchMedia("screen and (max-width: 640px)").matches) {
      return "phone";
    }

    if (
      window.matchMedia("screen and (min-width: 641px) and (max-width: 1024px)")
        .matches
    ) {
      return "tablet";
    }

    if (
      window.matchMedia(
        "screen and (min-width: 1008px) and (max-width: 1279px)"
      ).matches
    ) {
      return "lap";
    }

    if (window.matchMedia("screen and (min-width: 1280px)").matches) {
      return "desk";
    }
  }
}

class Dropdown {
  constructor() {
    this.domDelegate = new Delegate(document.body);
    this.breakpoint = new Responsive().getCurrentBreakpoint();
    this.allDropdowns = document.querySelectorAll(".Dropdown");

    this.bindEvents();
  }

  bindEvents() {
    // Bind event for general dropdown toggle
    this.domDelegate.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );

    let selector;

    switch (this.breakpoint) {
      case "lap-and-up":
        // For lap-and-up breakpoint, bind event for desktop dropdown toggle
        selector = "[data-action=toggle-desktop-dropdown]";
        break;
      case "pocket":
        // For pocket breakpoint, bind event for mobile dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
        break;
      default:
        // If no specific breakpoint, set selector as false to skip binding
        selector = false;
        break;
    }

    if (selector) {
      // Bind event for specific breakpoint dropdown toggle
      this.domDelegate.on("click", selector, this.toggleDropdown.bind(this));
    }
  }

  openDropdown(elem, target) {
    // Open the dropdown by setting appropriate attributes and performing animation
    this.allDropdowns.forEach((dropdown) => {
      if (
        dropdown !== target.closest(".Dropdown") &&
        dropdown.querySelector("[aria-expanded='true']")
      ) {
        this.closeDropdown(dropdown);
      }
    });
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");
    DropdownButton.setAttribute("aria-expanded", "true");
    DropdownButton.style.pointerEvents = "none";
    setTimeout(() => (DropdownButton.style.pointerEvents = "all"), 250);

    new RevolutionAnimation(DropdownContent, "true").slideDown();
  }

  closeDropdown(elem) {
    // Close the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    new RevolutionAnimation(DropdownContent, "true").slideUp();
    DropdownButton.setAttribute("aria-expanded", false);
    DropdownButton.style.pointerEvents = "none";
    setTimeout(function () {
      if (DropdownContent.getAttribute("aria-hidden") == "false")
        DropdownContent.setAttribute("aria-hidden", "true");

      DropdownButton.style.pointerEvents = "all";
    }, 250);
  }

  toggleDropdown(event, target) {
    event.preventDefault();
    const mainDropdown = target.closest(".Dropdown");
    const isOpen = target.getAttribute("aria-expanded") === "true";

    if (isOpen) {
      // If dropdown is open, close it
      this.closeDropdown(mainDropdown, target);
    } else {
      // If dropdown is closed, open it
      this.openDropdown(mainDropdown, target);
    }
  }
}

new Dropdown();

class RevolutionSwiper {
  constructor(element, additionalSwiper) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    this.initialConfig = JSON.parse(
      element.getAttribute("data-swiper-settings")
    );

    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(
        additionalSwiper.getAttribute("data-swiper-thumb-settings")
      );
    }
    this.options = options;
    this.build();
  }

  selectCell(index) {
    this.swiperElement.slideTo(index);
  }

  resize() {
    this.swiperElement.resize();
  }

  build() {
    var _this = this,
      configThumb = this.initialConfigThumbs;
    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
    }

    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    if (
      this.swiperElement.el.classList.contains(
        "pressQuote--swiperMainMobile"
      ) ||
      this.swiperElement.el.classList.contains("pressQuote--swiperThumbsMobile")
    ) {
      this.swiperElement.on("slideNextTransitionStart", function (event) {
        _this.element.dispatchEvent(
          new CustomEvent("swiper:slideTransitionNext", {
            bubbles: true,
            detail: {
              event: event,
            },
          })
        );
      });

      this.swiperElement.on("slidePrevTransitionStart", function (event) {
        _this.element.dispatchEvent(
          new CustomEvent("swiper:slideTransitionPrev", {
            bubbles: true,
            detail: {
              event: event,
            },
          })
        );
      });
    }

    this.swiperElement.on("slideChange", function () {
      _this.element.dispatchEvent(
        new CustomEvent("swiper:slide-changed", {
          bubbles: true,
          detail: {
            currentIndex: _this.swiperElement.activeIndex,
            element: _this.swiperElement.el[0],
          },
        })
      );
    });
  }
}
class Drawer {
  constructor(element) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");

    this.headerTransparent = document.body
      .querySelector("#header")
      .classList.contains("Header--Transparent")
      ? true
      : false;

    if (this.element.classList.contains("MobileMenu--wrapper")) {
      this.hamburger = document.body.querySelector(".menuIcon--hamburger");
      this.xIcon = document.body.querySelector(".menuIcon--xIcon");
    }

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
    this.onOpen = options["onOpen"] || function () {};
    this.onClose = options["onClose"] || function () {};
    this.isOpen = false;

    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on(
      "click",
      '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.openDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.closeDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.toggleDrawer.bind(this)
    );
    this._openListener = this.openDrawer.bind(this);
    this._closeListener = this.closeDrawer.bind(this);
    this.calculateMaxHeightListener = this.maxHeight.bind(this);
    window.addEventListener("resize", this.calculateMaxHeightListener);

    this.delegateBody.on("drawer:close-other", this._closeListener);
  }

  maxHeight() {
    this.element.style.height = window.innerHeight + "px";

    if (this.element.getAttribute("id") == "Drawer") {
      const visibleHeightHeader = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue(
          "--header-height"
        ),
        10
      );
      const visibleHeightAnnBar = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue(
          "--announcement-height"
        ),
        10
      );
      const footerHeightDrawer =
        this.element.querySelector(".Drawer--Footer").offsetHeight;
      this.element.querySelector(
        "#Drawer .Drawer--Wrapper"
      ).style.height = `calc(100% - ${footerHeightDrawer}px)`;

      this.element.style.height =
        window.innerHeight - visibleHeightAnnBar - visibleHeightHeader + "px";
    }
    if (
      this.element.getAttribute("id") == "cart" ||
      this.element.getAttribute("id") == "sidebarFavorites"
    ) {
      var footer = this.element.querySelector(".CartDrawer--Footer");
      var footerHeight = 0;
      if (footer !== null) {
        footerHeight = footer.offsetHeight;
      }

      var headerEl = this.element.querySelector(".CartHeader");
      if (headerEl) {
        var header = headerEl.offsetHeight;
        if (this.element.querySelector(".emptyItem")) header = 0;
      }

      var itemWrapper = this.element.querySelector(".CartItems--Wrapper");

      if (itemWrapper !== null) {
        itemWrapper.style.height =
          window.innerHeight - footerHeight - header + "px";
      }
    }
  }

  toggleDrawer() {
    event.preventDefault();
    this.isOpen ? this.closeDrawer() : this.openDrawer();
  }

  openDrawer() {
    if (this.headerTransparent) {
      document.body
        .querySelector("#header")
        .classList.remove("Header--Transparent");
    }
    if (this.element.classList.contains("MobileMenu--wrapper")) {
      this.hamburger ? (this.hamburger.style.display = "none") : null;
      this.xIcon ? (this.xIcon.style.display = "flex") : null;
    }
    this.element.dispatchEvent(
      new CustomEvent("drawer:close-other", { bubbles: true })
    );

    if (this.element.id != "subscriptionDrawer") {
      this.element.dispatchEvent(
        new CustomEvent("close:search", { bubbles: true })
      );
    } else {
      this.element.dispatchEvent(
        new CustomEvent("sub:opened", {
          bubbles: true,
          detail: {
            product: event.target.closest('[data-action="toggle-drawer"]')
              .dataset.productid,
          },
        })
      );
    }

    if (this.element.getAttribute("id") == "cart") {
      this.element.dispatchEvent(
        new CustomEvent("cart-drawer:open", { bubbles: true })
      );
    }
    if (this.isOpen) {
      return;
    }

    this.maxHeight();
    if (this.element.getAttribute("id") == "Drawer") {
      /*   document.querySelector(".Drawer--Close").style.display = "block"; */
      this.element.dispatchEvent(
        new CustomEvent("sidebar-drawer:open", {
          bubbles: true,
        })
      );

      this.pageOverlayElement.style.opacity = 0;
    }
    this.element.setAttribute("aria-expanded", "true");
    this.pageOverlayElement.classList.add("is-visible");
    this.pageOverlayElement.addEventListener("click", this._closeListener);
    var focus = this.element.querySelector("[data-scrollable]");
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    document.body.classList.add("scrollLock");
    this.isOpen = true;
    setTimeout(() => {
      trapFocus(this.element);
    }, 400);
    this.onOpen();
    return false;
  }

  closeDrawer(event) {
    if (!this.isOpen) {
      return;
    }
    if (event) {
      event.preventDefault();
    }

    if (this.element.getAttribute("id") == "Drawer") {
      document.body
        .querySelectorAll(".SidebarDrawer--SecondLevel")
        .forEach((item) => {
          item.setAttribute("aria-hidden", "true");
        });
    }
    document.body.classList.remove("scrollLock");

    bodyScrollLock.clearAllBodyScrollLocks();

    this.element.setAttribute("aria-expanded", "false");

    if (this.headerTransparent && !document.body.querySelector("#header").classList.contains("Header--Scrolled")) {
      document.body
        .querySelector("#header")
        .classList.add("Header--Transparent");
    }
    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener("click", this._closeListener);
    removeTrapFocus(this.element);
    this.isOpen = false;
    this.onClose();

    if (this.element.classList.contains("MobileMenu--wrapper")) {
      this.hamburger ? (this.hamburger.style.display = "flex") : null;
      this.xIcon ? (this.xIcon.style.display = "none") : null;
    }
  }
}

class RevolutionAnimation {
  constructor(element, directAnimation) {
    this.element = element;
    if (!directAnimation) {
      this.intersectionObserver = [];
      this.integer = 0;
      var contentToAnimate = document.querySelectorAll("[data-animation]");
      contentToAnimate.forEach((item, i) => {
        this.animateElement(item, i);
        this.integer = this.integer + 1;
      });

      // Listen for changes to the DOM and animate any new elements
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const newContentToAnimate =
                node.querySelectorAll("[data-animation]");

              newContentToAnimate.forEach((item, i) => {
                this.animateElement(item, this.integer);
                this.integer = this.integer + 1;
              });
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  slideUp() {
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.offsetHeight;
    this.element.style.height = 0;
  }

  slideDown() {
    if (this.element.style.height === "auto") {
      return;
    }
    this.element.style.pointerEvents = "none";
    var _this = this;
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.setAttribute("aria-hidden", false);
    var transitionEnded = function transitionEnded(event) {
      _this.element.style.pointerEvents = "all";
      if (event.propertyName === "height") {
        _this.element.style.height = "auto";
        _this.element.removeEventListener("transitionend", transitionEnded);
      }
    };

    this.element.addEventListener("transitionend", transitionEnded);
  }

  // A function to animate a list of elements by scaling them out
  elementScaleOut(elements) {
    // Get the animation duration and delay from the theme settings
    const animationDuration = window.theme.animationDuration * 2;
    const animationDelay = window.theme.animationBetweenElements;

    // Loop through each element in the list
    elements.forEach((element, index) => {
      // Check if the element has already been loaded
      if (element.hasAttribute("data-loaded")) {
        // If so, skip this element
        return;
      }

      // Mark the element as loaded to prevent duplicate animations
      element.setAttribute("data-loaded", true);

      // Define the animation keyframes
      const keyframes = [
        { transform: "scale(104%)", opacity: "0" },
        { transform: "scale(100%)", opacity: "1" },
      ];

      // Define the animation options
      const animationOptions = {
        duration: animationDuration,
        fill: "forwards",
      };

      // Schedule the animation with a delay based on the element's position in the list
      setTimeout(() => {
        element.animate(keyframes, animationOptions);
      }, animationDelay * index);
    });
  }

  elementScaleIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "scale(96%)", opacity: "0" },
          { transform: "scale(100%)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration * 2,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromTop(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(-30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromBottom(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromRight(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeft(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromRightBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeftBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  imageUnravel(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { opacity: "0" },
          { opacity: "1" },
        ];
        item.animate(elementMove, {
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.classList.add("show"); // Add the 'show' class to reveal the image
        setTimeout(() => {
          item.classList.remove("reveal");
          item.classList.add("zoomImgOut");
        }, 1000);
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  animateElement(animatedItem, index) {
    const options = {
      integer: index,
      type: animatedItem.dataset.animation,
    };

    if (this.intersectionObserver[index]) {
      this.intersectionObserver[index].disconnect();
    }

    this.intersectionObserver[index] = new IntersectionObserver(
      (results) => {
        const integer = options.integer;
        const elements = [];

        // Iterate over the IntersectionObserverEntry objects in the results array.
        results.forEach((result) => {
          // Check if the target element is intersecting the root element or if its intersection ratio is greater than 0.
          if (result.isIntersecting || result.intersectionRatio > 0) {
            // Add the target element to the elements array.
            elements.push(result.target);
            // Unobserve the target element.
            this.intersectionObserver[integer].unobserve(result.target);
          }
        });

        // If there are no elements to reveal, return.
        if (elements.length === 0) {
          return;
        }

        // An object that maps each animation type to the corresponding animation function.
        const animations = {
          elementFromTop: "elementFromTop",
          elementFromBottom: "elementFromBottom",
          elementFromRight: "elementFromRight",
          elementFromLeft: "elementFromLeft",
          elementFromLeftBig: "elementFromLeftBig",
          elementFromRightBig: "elementFromRightBig",
          elementScaleIn: "elementScaleIn",
          elementScaleOut: "elementScaleOut",
          imageUnravel: "imageUnravel",
        };

        // Get the animation function corresponding to the type from the animations object.
        const animation = animations[options.type];
        // If the animation function exists, call it with the elements array.
        if (animation) {
          this[animation](elements);
        }
      },
      { threshold: 0.25 }
    );

    if (animatedItem.classList.contains("animatedContent")) {
      this.intersectionObserver[index].observe(animatedItem);
    }

    animatedItem.querySelectorAll(".animatedContent").forEach((item) => {
      this.intersectionObserver[index].observe(item);
    });
  }
}

if (window.theme.enableAnimations) {
  document.addEventListener("DOMContentLoaded", function () {
    new RevolutionAnimation();
  });
}

/*
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.input = this.querySelector("input");
    this.changeEvent = new Event("quantity:changed", { bubbles: true });
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (this.options["noVariants"] == "true") {
      this.toggleAddButton();
    }
  }

  toggleAddButton() {
    let quantity = "";

    const addButton = document.querySelectorAll(".MainProduct--ATC"),
      addButtonInner = document.querySelectorAll(
        ".MainProduct--ATC .ButtonText"
      ),
      quantityEl = document.querySelector(".QuantitySelector__ProductQuantity");

    if (quantityEl) {
      quantity = quantityEl.value;
    }
    if (window.variantInfo.show_icon) {
      var buySvg =
        '<svg class="Svg Svg--shopping_cart mr-m" width="24" height="24" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.31 5.19547C25.1687 5.02127 24.9568 4.91946 24.7325 4.91797H9.11751L9.60501 6.41797H23.75L21.7475 15.418H10.4975L7.07001 4.56547C6.99476 4.33174 6.80986 4.14965 6.57501 4.07797L3.50001 3.13297C3.24278 3.05393 2.96292 3.11812 2.76584 3.30137C2.56877 3.48461 2.48443 3.75907 2.54459 4.02137C2.60476 4.28366 2.80028 4.49393 3.05751 4.57297L5.75001 5.39797L9.19251 16.273L7.96251 17.278L7.86501 17.3755C7.2374 18.0987 7.21221 19.1659 7.80501 19.918C8.21952 20.4221 8.84817 20.7002 9.50001 20.668H22.0175C22.4317 20.668 22.7675 20.3322 22.7675 19.918C22.7675 19.5038 22.4317 19.168 22.0175 19.168H9.38001C9.20436 19.162 9.0446 19.0646 8.95873 18.9113C8.87286 18.7579 8.87334 18.5709 8.96001 18.418L10.7675 16.918H22.3475C22.705 16.9267 23.0189 16.6818 23.0975 16.333L25.475 5.83297C25.5212 5.6064 25.4603 5.37117 25.31 5.19547ZM20.75 25.168C21.682 25.168 22.4375 24.4125 22.4375 23.4805C22.4375 22.5485 21.682 21.793 20.75 21.793C19.818 21.793 19.0625 22.5485 19.0625 23.4805C19.0625 24.4125 19.818 25.168 20.75 25.168ZM12.185 23.4805C12.185 24.4125 11.4295 25.168 10.4975 25.168C9.56553 25.168 8.81001 24.4125 8.81001 23.4805C8.81001 22.5485 9.56553 21.793 10.4975 21.793C11.4295 21.793 12.185 22.5485 12.185 23.4805Z" fill="#121212"></path></svg>';
    } else {
      var buySvg = "";
    }

    if (
      !addButton ||
      Array.from(addButton).some(
        (element) => element.getAttribute("disabled") === "disabled"
      )
    )
      return;
    if (!quantity) {
      quantity = 1;
    }

    addButton.forEach((btn) => {
      btn.removeAttribute("disabled");
      btn.classList.remove("ProductCard--Sold__Out");
    });
    if (window.variantInfo.show_price) {
      var priceElement =
        "<span class='u-pb1 mainProductPrice'>&nbsp;" +
        Shopify.formatMoney(
          this.options["price"] * quantity,
          window.theme.moneyFormat
        );
      +"</span>";
    } else {
      var priceElement = "";
    }

    addButtonInner.forEach(
      (btn) =>
        (btn.innerHTML =
          buySvg + window.variantStrings.addToCartFor + priceElement)
    );
  }
}


customElements.define("quantity-input", QuantityInput);
*/


class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.input = this.querySelector("input");
    this.changeEvent = new Event("quantity:changed", { bubbles: true });
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );

    // Validate quantity rules on initialization
    this.validateQtyRules();
  }

  connectedCallback() {
    this.validateQtyRules();
    // Add event listeners if necessary for dynamic updates (if used)
  }

  disconnectedCallback() {
    // Remove event listeners if necessary (if added in connectedCallback)
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    
    // Dispatch change event if value has changed
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }

    if (this.options["noVariants"] == "true") {
      this.toggleAddButton();
    }

    // Validate after button click to ensure min/max constraints are respected
    this.validateQtyRules();
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);

    // Check if the input has a min attribute and the minus button exists
    if (this.input.min) {
        const min = parseInt(this.input.min);
        const buttonMinus = this.querySelector(".quantity__button[name='minus']");
        
        if (buttonMinus) { // Add this check to ensure buttonMinus exists
            buttonMinus.classList.toggle('disabled', value <= min);
        }
    }

    // Check if the input has a max attribute and the plus button exists
    if (this.input.max) {
        const max = parseInt(this.input.max);
        const buttonPlus = this.querySelector(".quantity__button[name='plus']");
        
        if (buttonPlus) { // Add this check to ensure buttonPlus exists
            buttonPlus.classList.toggle('disabled', value >= max);
        }
    }
}


  toggleAddButton() {
    let quantity = "";

    const addButton = document.querySelectorAll(".MainProduct--ATC"),
      addButtonInner = document.querySelectorAll(
        ".MainProduct--ATC .ButtonText"
      ),
      quantityEl = document.querySelector(".QuantitySelector__ProductQuantity");

    if (quantityEl) {
      quantity = quantityEl.value;
    }
    if (window.variantInfo.show_icon) {
      var buySvg =
        '<svg class="Svg Svg--shopping_cart mr-m" width="24" height="24" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.31 5.19547C25.1687 5.02127 24.9568 4.91946 24.7325 4.91797H9.11751L9.60501 6.41797H23.75L21.7475 15.418H10.4975L7.07001 4.56547C6.99476 4.33174 6.80986 4.14965 6.57501 4.07797L3.50001 3.13297C3.24278 3.05393 2.96292 3.11812 2.76584 3.30137C2.56877 3.48461 2.48443 3.75907 2.54459 4.02137C2.60476 4.28366 2.80028 4.49393 3.05751 4.57297L5.75001 5.39797L9.19251 16.273L7.96251 17.278L7.86501 17.3755C7.2374 18.0987 7.21221 19.1659 7.80501 19.918C8.21952 20.4221 8.84817 20.7002 9.50001 20.668H22.0175C22.4317 20.668 22.7675 20.3322 22.7675 19.918C22.7675 19.5038 22.4317 19.168 22.0175 19.168H9.38001C9.20436 19.162 9.0446 19.0646 8.95873 18.9113C8.87286 18.7579 8.87334 18.5709 8.96001 18.418L10.7675 16.918H22.3475C22.705 16.9267 23.0189 16.6818 23.0975 16.333L25.475 5.83297C25.5212 5.6064 25.4603 5.37117 25.31 5.19547ZM20.75 25.168C21.682 25.168 22.4375 24.4125 22.4375 23.4805C22.4375 22.5485 21.682 21.793 20.75 21.793C19.818 21.793 19.0625 22.5485 19.0625 23.4805C19.0625 24.4125 19.818 25.168 20.75 25.168ZM12.185 23.4805C12.185 24.4125 11.4295 25.168 10.4975 25.168C9.56553 25.168 8.81001 24.4125 8.81001 23.4805C8.81001 22.5485 9.56553 21.793 10.4975 21.793C11.4295 21.793 12.185 22.5485 12.185 23.4805Z" fill="#121212"></path></svg>';
    } else {
      var buySvg = "";
    }

    if (
      !addButton ||
      Array.from(addButton).some(
        (element) => element.getAttribute("disabled") === "disabled"
      )
    )
      return;
    if (!quantity) {
      quantity = 1;
    }

    addButton.forEach((btn) => {
      btn.removeAttribute("disabled");
      btn.classList.remove("ProductCard--Sold__Out");
    });
    if (window.variantInfo.show_price) {
      var priceElement =
        "<span class='u-pb1 mainProductPrice'>&nbsp;" +
        Shopify.formatMoney(
          this.options["price"] * quantity,
          window.theme.moneyFormat
        );
      +"</span>";
    } else {
      var priceElement = "";
    }

    addButtonInner.forEach(
      (btn) =>
        (btn.innerHTML =
          buySvg + window.variantStrings.addToCartFor + priceElement)
    );
  }
}

// Register the custom element if not already registered
if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', QuantityInput);
}


function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
  copped
) {
  if (!copped) this.countryEl = document.getElementById(country_domid);
  else this.countryEl = country_domid;
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  if (this.provinceEl) this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    if (this.provinceEl) {
      this.clearOptions(this.provinceEl);
      if (provinces && provinces.length == 0) {
        this.provinceContainer.style.display = "none";
      } else {
        for (var i = 0; i < provinces.length; i++) {
          var opt = document.createElement("option");
          opt.value = provinces[i][0];
          opt.innerHTML = provinces[i][1];
          this.provinceEl.appendChild(opt);
        }

        this.provinceContainer.style.display = "";
      }
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    new AddToCart(this);
  }
}

customElements.define("product-form", ProductForm);

class Countdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    const counterWrapper = this.element.querySelector(
      ".component-countDownWrapper"
    );

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    let counterString = this.options["countdownString"];
    if (counterString) {
      counterString = counterString.replace(
        "{countdown}",
        '<span class="u-pb6 component-countDown">00:00:00</span>'
      );
      counterWrapper.innerHTML = counterString;
    }

    const dateNow = new Date();
    const todaysDay = dateNow.getDay();

    const countdownDay = this.options.countdownDays;

    this.dayDifference = countdownDay - todaysDay;

    if (this.dayDifference < 0) {
      // If the countdown day is earlier in the week, add 7 to the difference
      this.dayDifference += 7;
    }

    this.counter = this.element.querySelector(".component-countDown");
    setInterval(this.countDown.bind(this), 1000);
  }

  countDown() {
    const dateNow = new Date();
    const currentHours = dateNow.getHours();
    const currentMinutes = dateNow.getMinutes();
    let countDate = new Date(`March 3, 2099 ${this.options.countdownTime}`);

    if (this.options["countdownType"] == "to_date") {
      countDate = new Date(this.options.countdownDate);
    }

    const difference = countDate - dateNow;

    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;

    let textDays = Math.floor(difference / (1000 * 60 * 60 * 24));
    let textHours = Math.floor((difference % days) / hours);
    let textMinutes = Math.floor((difference % hours) / minutes);
    let textSeconds = Math.floor((difference % minutes) / seconds);

    const [targetHours, targetMinutes] = this.options.countdownTime
      .split(":")
      .map(Number);
    if (
      targetHours < currentHours ||
      (targetHours === currentHours &&
        targetMinutes <= currentMinutes &&
        this.options["countdownType"] == "reccuring")
    ) {
      textDays = this.dayDifference - 1;
    } else if (this.options["countdownType"] == "reccuring") {
      textDays = this.dayDifference;
    }

    const displayHours = textHours;
    const formatHours = displayHours < 10 ? `0${displayHours}` : displayHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;

    if (textDays > 0) {
      this.counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`;
    } else {
      this.counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`;
    }
  }
}

customElements.define("countdown-element", Countdown);

sessionStorage.setItem("firstLoadCart", true);
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.Drawer = new Drawer(this.element);
    this.loader = this.element.querySelector(".itemLoader");
    this.cartCount = document.querySelector(".CartCount");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.breakpoint = new Responsive().getCurrentBreakpoint();
    if (sessionStorage.getItem("firstLoadCart") === "true") {
      sessionStorage.setItem("firstLoadCart", false);
      if (this.options["showRecommendations"]) {
        this.loadRecommendations();
      }
    }
    new AddToCart(this.element);

    this.bindEvents();
  }
  onUnload() {
    this.delegateElement.off();
    document.removeEventListener("product:added", this.onProductAddedListener);
  }
  bindEvents() {
    if (window.theme.listener == "false") {
      this.onProductAddedListener = this.onProductAdded.bind(this);
      document.addEventListener("cart-drawer:open", this.onOpen.bind(this));
      document.addEventListener("product:added", this.onProductAddedListener);
      this.delegateElement.on(
        "click",
        '[data-action="update-item-quantity"], [data-action="remove-item"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "change",
        '[data-action="update-change-quantity"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "quantity:changed",
        ".QuantitySelector__CurrentQuantity",
        this.updateItemQuantity.bind(this)
      );

      window.theme.listener = "true";
    }
  }
  onOpen() {
    if (this.element.getAttribute("aria-expanded") == "false") {
      document.documentElement.style.setProperty(
        "--cartHeader-height",
        document.querySelector(".CartHeader").offsetHeight + "px"
      );
    }
  }
  updateItemQuantity(event, target) {
    event.preventDefault();
    target
      .closest(".cartItem")
      .querySelector(".itemLoader")
      .classList.add("is-visible");
    var _this = this;

    var quantity = null;
    if (target.tagName === "INPUT") {
      quantity = parseInt(Math.max(parseInt(target.value) || 0, 0));
    } else {
      quantity = parseInt(target.getAttribute("data-quantity"));
    }

    fetch(window.routes.localeRootUrl + "/cart/change.js", {
      body: JSON.stringify({
        id: target.getAttribute("data-line-id"),
        quantity: quantity,
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      _this.renderCart(target.getAttribute("data-id"), true);
      if (response.ok) {
        response.json().then(function (cartData) {
          const newArray = cartData.items.map(item => ({
            id: item.id,
            quantity: item.quantity
          }));        

          if(localStorage.getItem('oldCartState')) {
            compareArrays(JSON.parse(localStorage.getItem('oldCartState')), newArray);
          }
          localStorage.setItem('oldCartState', JSON.stringify(newArray));
        });
      }
    });
  }

  onProductAdded(e) {
    var _this = this;

    if (e.detail.onlyRender) {
      this.disableScroll = false;
      this.renderCart();
    } else {
      this.disableScroll = true;
      this.renderCart().then(function () {
        _this.Drawer.openDrawer();
      });
    }
  }

  renderCart(lineNumber, quantityChange) {
    this.pageLoader.style.width = 100 + "%";

    var _this = this;
    return fetch(
      window.routes.localeRootUrl + "/?section_id=main-cart_drawer",
      {
        credentials: "same-origin",
        method: "GET",
      }
    ).then(function (content) {
      content.text().then(function (html) {
        _this.replaceContent(html, lineNumber, quantityChange);
      });
    });
  }

  replaceContent(html, lineNumber, quantityChange) {
    var _this = this;
    this.pageLoader.style.left = "unset";
    this.pageLoader.style.right = 0 + "px";
    this.pageLoader.style.width = 0 + "%";
    setTimeout(() => {
      this.pageLoader.style.left = 0 + "px";
      this.pageLoader.style.right = "unset";
    }, 550);
    var tempElement = document.createElement("div");
    tempElement.innerHTML = html;
    this.tempOptions = JSON.parse(
      tempElement.querySelector("#cart").getAttribute("data-settings")
    );

    var number = this.tempOptions["itemCount"];
    this.cartCount.innerHTML = number;
    window.theme.cartCount = parseInt(number);
    if (lineNumber) {
      var cartNodeParent = this.element.querySelector("#" + lineNumber);
      const itemToReplaceWith = tempElement.querySelector(
        "#" + lineNumber + " .cartItem--Informations"
      );
      if (cartNodeParent && cartNodeParent.querySelector(".itemLoader")) {
        cartNodeParent
          .querySelector(".itemLoader")
          .classList.remove("is-visible");
      }
      if (itemToReplaceWith) {
        cartNodeParent.replaceChild(
          itemToReplaceWith,
          cartNodeParent.querySelector(".cartItem--Informations")
        );
      } else {
        cartNodeParent.classList.add("removing");
        cartNodeParent.animate(
          [
            // keyframes
            { transform: "translateY(0px)", opacity: "1" },
            { transform: "translateY(30px)", opacity: "0" },
          ],
          {
            // timing options
            duration: 500,
            fill: "forwards",
          }
        );
        setTimeout(() => {
          cartNodeParent.remove();
        }, 500);
      }

      if (this.options["showRecommendations"]) {
        this.loadRecommendations();
      }

      if (number > 0) {
        const checkoutButtonParent = this.element.querySelector(
          ".CartFooter--Buttons"
        );
        const checkoutButtonToReplace = tempElement.querySelector(
          ".cartCheckout--Button"
        );
        checkoutButtonParent.replaceChild(
          checkoutButtonToReplace,
          checkoutButtonParent.querySelector(".cartCheckout--Button")
        );

        const footerTotalParent = this.element.querySelector(
          ".MetaIcon--Wrappers"
        );
        const footerTotalToReplace = tempElement.querySelector(
          ".CartFooter--Totals"
        );
        if (footerTotalParent && footerTotalToReplace) {
          footerTotalParent.replaceChild(
            footerTotalToReplace,
            footerTotalParent.querySelector(".CartFooter--Totals")
          );
        }

        const cartFreeShippingParent = this.element.querySelector(
          ".cartDrawer--freeShipping"
        );
        const cartFreeShippingToReplace = tempElement.querySelector(
          ".cartDrawer--freeShippingLeftContent"
        );

        const shippingBarTemp = tempElement.querySelector(
          ".cartDrawer--freeShippingLeftMoneyProgress"
        );
        const shippingBarCurrent = this.element.querySelector(
          ".cartDrawer--freeShippingLeftMoneyProgress"
        );

        if (cartFreeShippingToReplace) {
          cartFreeShippingParent.replaceChild(
            cartFreeShippingToReplace,
            cartFreeShippingParent.querySelector(
              ".cartDrawer--freeShippingLeftContent"
            )
          );

          if (shippingBarTemp && shippingBarCurrent) {
            shippingBarCurrent.style.width = shippingBarTemp.style.width;
          } else if (shippingBarCurrent && !shippingBarTemp) {
            shippingBarCurrent.remove();
          } else {
            cartFreeShippingParent.append(
              tempElement.querySelector(
                ".cartDrawer--freeShippingLeftMoneyProgressBar"
              )
            );
          }
        }
      } else {
        this.element
          .querySelector(".CartDrawer--Footer")
          .classList.add("removing");

        const mainPartParent = this.element.querySelector(".CartDrawer");

        mainPartParent.innerHTML =
          tempElement.querySelector(".CartDrawer").innerHTML;

        if (window.theme.enableAnimations) {
          const mainPartchildren =
            mainPartParent.querySelector("#main-cartItems");
          mainPartchildren.animate(
            [
              // keyframes
              { opacity: "0" },
              { opacity: "1" },
            ],
            {
              // timing options
              duration: 500,
              fill: "forwards",
            }
          );
        }

        const cartFreeShippingParent = this.element.querySelector(
          ".cartDrawer--freeShipping"
        );
        const cartFreeShippingToReplace = tempElement.querySelector(
          ".cartDrawer--freeShippingLeftContent"
        );

        const shippingBarTemp = tempElement.querySelector(
          ".cartDrawer--freeShippingLeftMoneyProgress"
        );
        const shippingBarCurrent = this.element.querySelector(
          ".cartDrawer--freeShippingLeftMoneyProgress"
        );

        if (cartFreeShippingToReplace) {
          cartFreeShippingParent.replaceChild(
            cartFreeShippingToReplace,
            cartFreeShippingParent.querySelector(
              ".cartDrawer--freeShippingLeftContent"
            )
          );

          if (shippingBarTemp && shippingBarCurrent) {
            shippingBarCurrent.style.width = shippingBarTemp.style.width;
          } else if (shippingBarCurrent && !shippingBarTemp) {
            shippingBarCurrent.remove();
          } else {
            cartFreeShippingParent.append(
              tempElement.querySelector(
                ".cartDrawer--freeShippingLeftMoneyProgressBar"
              )
            );
          }
        }
      }
      if (this.element.querySelector(".itemLoader")) {
        setTimeout(() => {
          this.element
            .querySelector(".itemLoader")
            .classList.remove("is-visible");
        }, 250);
      }
    } else {
      const cartNodeParent =
        this.element.querySelector(".CartDrawer").parentNode;
      const currentScrollPosition =
        this.element.querySelector("#main-cartItems").scrollTop;

      cartNodeParent.replaceChild(
        tempElement.querySelector(".CartDrawer"),
        this.element.querySelector(".CartDrawer")
      );
      this.element.querySelector("#main-cartItems").scrollTop =
        currentScrollPosition;
    }
    setTimeout(() => {
      if (this.options["showRecommendations"] && !quantityChange) {
        this.loadRecommendations();
      }

      var focus = _this.element.querySelector("[data-scrollable]");
      if (this.disableScroll)
        bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      _this.Drawer.maxHeight();
    }, 200);
  }

  loadRecommendations() {
    if (this.options["productId"] == "") {
      var url = "?section_id=helper-recommendations";
    } else {
      var url =
        window.routes.localeRootUrl +
        "/recommendations/products?section_id=helper-recommendations&product_id=" +
        this.options["productId"] +
        "&limit=10";
    }

    var _this = this;
    return fetch(url).then(function (response) {
      return response
        .text()
        .then(function (content) {
          var container = document.createElement("div");
          container.innerHTML = content;
          var z = container.querySelector(".cartUpsell").innerHTML;
          var x = _this.element.querySelector(".withItemRecommendations");
          x.innerHTML = z;

          const recommPresent = container
            .querySelector(".cartUpsell")
            .querySelector("product-card");
          if (recommPresent)
            _this.element.querySelector(
              ".CartDrawer--Recommendations"
            ).style.display = "block";
          else
            _this.element.querySelector(
              ".CartDrawer--Recommendations"
            ).style.display = "none";

          const swiper = new Swiper(".swiperUpsell", {
            // Default parameters
            noSwipingClass: "noSwipe",
            slidesPerView: 2,
            spaceBetween: 16,
            slidesOffsetAfter: 0,
            slidesOffsetBefore: 0,
            resistanceRatio: 0,
            scrollbar: {
              el: ".cart-scrollbar",
              draggable: true,
            },
            breakpoints: {
              767: {
                slidesPerView: 2,
                spaceBetween: 40,
              },
            },
          });
        })
        .catch((e) => {
          console.error(e);
        });
    });
  }
}
customElements.define("cart-drawer", CartDrawer);

class FeaturedCollectionSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);

    this.bindEvents();

    new AddToCart(this.element);
  }

  bindEvents() {
    this.isPageLoaded =
      document.readyState === "complete" ||
      document.readyState === "loaded" ||
      document.readyState === "interactive";
    if (!this.isPageLoaded) {
      window.addEventListener("load", this.onPageLoaded.bind(this));
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.carousel = new RevolutionSwiper(this.carouselElement);
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "-100px 0px 200px 0px",
    }).observe(this);
  }
}
customElements.define("featured-collection", FeaturedCollectionSection);

class SliderTextSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);
  }
}
customElements.define("slider-text", SliderTextSection);

class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.scrollableElement = this.element.querySelector("[data-scrollable]");
    this.headerTransparent = false;
    const selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }

    this.accountDropdown = this.element.querySelector('.header--AccountDropdown');

    this.carousel = [];
    this.carouselElement = this.element.querySelectorAll(
      ".desktopMenu--submenuSwiper"
    );
    this.carouselElement.forEach((item, index) => {
      this.carousel[index] = new RevolutionSwiper(item);
    });

    if (this.options.sticky) {
      this.toggleSticky();
    }

    this.updateVisibleHeight();
    this.bindEvents();
    this.menuOverlapHandler();
  }

  updateVisibleHeight() {
    const rect = this.element.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate the visible height
    let visibleHeight =
      Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

    // Ensure the visibleHeight is never negative
    visibleHeight = Math.max(visibleHeight, 0);
    // Update the height of header with the visible height
    document.documentElement.style.setProperty(
      "--header-dynamic-height",
      `${visibleHeight}px`
    );
  }

  menuOverlapHandler() {
    var currentClientWidth = Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );

    var menuItems = this.element.querySelector(".header--MenuItems"),
      overlapping = false,
      menuWrapper = this.element.querySelector(".header--Wrapper"),
      allHeights = [],
      _this = this;
    if (menuItems) {
      var desiredHeight = _this.element.querySelectorAll(".mainLinks");
      desiredHeight.forEach((item) => {
        allHeights.push(item.offsetHeight);
      });
      var maxHeight = Math.max.apply(null, allHeights);
      var minHeight = Math.min.apply(null, allHeights);
      if (maxHeight > minHeight) {
        overlapping = true;
        if (
          window.theme.menuBreakpoint == 0 ||
          window.theme.menuBreakpoint == undefined
        ) {
          window.theme.menuBreakpoint = currentClientWidth;
        }
      }
    }
    if (currentClientWidth > window.theme.menuBreakpoint) {
      
      menuItems.classList.remove("mt-m");
      menuItems.classList.remove("mainMenu--Overlapping");
      menuWrapper.querySelector(".mainMenuItems").prepend(menuItems);
      window.theme.menuBreakpoint = 0;
    } else if (overlapping) {
      menuItems.classList.add("mt-m");
      menuItems.classList.add("mainMenu--Overlapping");
      menuItems.closest(".header").appendChild(menuItems);
    }
    document.documentElement.style.setProperty(
      "--header-height-fixed",
      _this.element.clientHeight + "px"
    );
    menuItems.style.opacity = 1;
  }

  toggleSticky() {
    this.element.parentElement.classList.add("header--Sticky");
    this.element.parentElement.classList.remove("Header--Transparent");
  }

  bindEvents() {
    const _this = this;
    document.addEventListener("shopify:section:load", function () {
      _this.menuOverlapHandlerListener();
    });
    this.menuOverlapHandlerListener = this.menuOverlapHandler.bind(this);
    window.addEventListener("resize", this.menuOverlapHandlerListener);
    this.toggleColorListener = this.toggleColor.bind(this);

    window.addEventListener("scroll", this.updateVisibleHeight.bind(this));
    window.addEventListener("resize", this.updateVisibleHeight.bind(this));
    window.addEventListener("scroll", this.toggleColorListener);
    this.delegateBody.on("menu:close", this.closeMenu.bind(this), true);

    this.delegateElement.on(
      "mouseenter",
      "[aria-hasMenu='true']",
      this.openMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "focusin",
      "[aria-hasMenu='true']",
      this.openMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "mouseleave",
      "[aria-submenu]",
      this.closeMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "mouseenter",
      "[aria-singlemenu]",
      this.closeMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "focusin",
      "[aria-singleMenu], .mainLinks",
      this.closeMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "click",
      '[data-action="open-account"]',
      this.openAccountDropdown.bind(this)
    );

    window.addEventListener("scroll", this.updateVisibleHeight.bind(this));
    window.addEventListener("resize", this.updateVisibleHeight.bind(this));
  }

  openAccountDropdown(e) {
    if(e.target.closest('.header--AccountDropdown ')) return;

    e.stopPropagation();

    const clickHandler = () => {
      this.accountDropdown.classList.remove("opened");
      this.delegateBody.off("click", clickHandler);
    };

    if(this.accountDropdown.classList.contains("opened")) {
      this.accountDropdown.classList.remove("opened");
    } else {
      this.accountDropdown.classList.add("opened");
      this.delegateBody.on("click", clickHandler);
    }
  }

  updateMenuPosition() {
    document.documentElement.style.setProperty(
      "--submenu-position",
      `${document.querySelector("#header").offsetHeight}px`
    );
  }

  openMenu(event, target) {
    this.carousel.forEach((swiper) => {
      swiper.swiperElement.update();
    });

    // Dispatch a custom event to indicate that the menu is being opened.
    this.element.dispatchEvent(new CustomEvent("menu:open", { bubbles: true }));

    // If the event is a mouseenter event and the target is not the same as the event target, return.
    if (event.type === "mouseenter" && target !== event.target) {
      return;
    }

    // Update the position of the menu and change the ARIA expanded attribute.
    this.updateMenuPosition(target);

    if (this.element.classList.contains("Header--Transparent")) {
      this.element.classList.remove("Header--Transparent");
      this.headerTransparent = true;
    }

    target.setAttribute("aria-expanded", "true");

    // Close any siblings of the target element.
    const siblings = Array.from(target.parentElement.children).filter(
      (child) =>
        child !== target && child.getAttribute("aria-expanded") === "true"
    );
    siblings.forEach((item) => item.setAttribute("aria-expanded", "false"));

    // Disable body scroll on the scrollable element inside the menu.
    bodyScrollLock.disableBodyScroll(
      this.scrollableElement,
      bodyScrollLockOptions
    );
  }

  closeMenu(event, target) {
    if (event.type === "mouseleave" && target !== event.target) {
      return;
    }

    const allOpen = this.element.querySelectorAll('[aria-expanded="true"]');
    allOpen.forEach(function (item) {
      item.setAttribute("aria-expanded", "false");
    });

    if (!event.target.classList.contains("RevolutionSelectbox")) {
      if (!this.element.classList.contains("search-opened")) {
        this.toggleColor();
      }
    }

    bodyScrollLock.enableBodyScroll(this.scrollableElement);
  }

  toggleColor() {
    document.documentElement.style.setProperty(
      "--window-height",
      window.innerHeight + "px"
    );
    setTimeout(
      () =>
        document.documentElement.style.setProperty(
          "--window-height",
          window.innerHeight + "px"
        ),
      350
    );

    if (window.pageYOffset > 25) {
      this.element.classList.add("Header--Scrolled");
    } else {
      this.element.classList.remove("Header--Scrolled");
    }
    if (this.options.transparent) {
      if (window.pageYOffset > 25 && this.options.sticky) {
        this.element.classList.remove("Header--Transparent");
      } else {
        this.element.classList.add("Header--Transparent");
      }
    }
    if (this.options.transparent_d) {
      if (window.pageYOffset > 25 && this.options.sticky) {
        this.element.classList.remove("Header--Transparent");
      } else {
        this.element.classList.add("Header--Transparent");
      }
    }
  }
}
customElements.define("header-component", Header);
class AccountSelectbox extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    let responsive = new Responsive();
    this.breakpoint = responsive.getCurrentBreakpoint();
    var location = this.element.getAttribute("data-settings");

    if (location == "sidebarMenu") {
      var additionalOverlay = true;
    } else {
      var additionalOverlay = false;
    }

    if (this.breakpoint === "phone" || this.breakpoint === "tablet") {
      this.selectBox = this.element.querySelector(".accountSelectbox");
      this.selectBox = new RevolutionSelectbox(
        this.selectBox,
        true,
        additionalOverlay
      );
    }

    this.bindEvents();
  }
  bindEvents() {}
}
customElements.define("account-selectbox", AccountSelectbox);
class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    let responsive = new Responsive();
    this.breakpoint = responsive.getCurrentBreakpoint();

    const allDrawer = this.element.querySelectorAll(".Drawer--wrapper");
    allDrawer.forEach((item) => {
      new Drawer(item);
    });
    this.carouselElement = this.element.querySelectorAll(
      ".mobileMenu--submenuSwiper"
    );
    this.carouselElement.forEach((item) => {
      this.carousel = new RevolutionSwiper(item);
    });

    this.bindEvents();
  }
  bindEvents() {
    document.addEventListener("sidebar-drawer:open", this.onDrawerListener);

    this.delegateElement.on(
      "click",
      '[data-action="toggle-subdrawer"]',
      this.toggleNextElement.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="toggle-prev-subdrawer"]',
      this.togglePreviusElement.bind(this)
    );
  }

  toggleNextElement(event, target) {
    event.preventDefault();
    let nextEl = target.getAttribute("data-toggle-id"),
      subdrawer = this.element.querySelector("#" + nextEl);
    subdrawer.setAttribute("aria-hidden", "true");

    if (subdrawer && subdrawer.getAttribute("aria-hidden") == "true") {
      let focus = subdrawer.querySelector("[data-scrollable]");
      subdrawer.setAttribute("aria-hidden", "false");
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    }
  }

  togglePreviusElement(event, target) {
    const focus = target.closest(".SidebarDrawer--Wrapper");
    focus.setAttribute("aria-hidden", "true");
    bodyScrollLock.enableBodyScroll(focus, bodyScrollLockOptions);
  }
}
customElements.define("main-menu-dropdown", MainMenuDropdown);

class Transition {
  constructor() {
    this.pageOverlay = document.querySelector(".pageTransition");

    if (!this.isPageLoaded) {
      document.addEventListener(
        "DOMContentLoaded",
        this.onPageLoaded.bind(this)
      );
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 100,
        fill: "forwards",
        easing: "ease-in-out",
        iterations: 1,
      });
    }
  }

  onPageUnload(event, target) {
    if (
      event.defaultPrevented ||
      event.ctrlKey ||
      event.metaKey ||
      !window.theme.showPageTransition ||
      !this.pageOverlay
    ) {
      return;
    }

    event.preventDefault(); // Prevent the click to happen

    if (this.pageOverlay) {
      var timeline = new TimelineLite({
        onComplete: function onComplete() {
          window.location.href = target.href;
        },
      });

      timeline.fromTo(
        this.pageOverlay,
        0.25,
        { autoAlpha: 0, ease: Linear.easeNone },
        { autoAlpha: 1, ease: Linear.easeNone }
      );
    }
  }
}
new Transition();

class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.trueObserver = false;

    if (this.options["using_fade"] == "fade") {
      if (
        this.element.dataset.position == 0 ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-active") ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-duplicate-active")
      ) {

        this.checkLoaded();
        this.bindEvents();
      } else {
        this.bindEvents();
      }
    } else {

      this.checkLoaded();
    }
  }

  bindEvents() {
    window.removeEventListener(
      "swiper:slide-changed",
      this.onSlideChangeListener
    );
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  checkLoaded() {
    var _this = this;
    if (typeof videojs !== "undefined") {
      this.videoPlayerInitialization();
    } else {
      loadScript(window.theme.videoScript);
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {
    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
    if (event.detail.currentIndex == this.elementPosition) {
      if (!this.element.getAttribute("loaded")) {
        var node = document.createElement("div");
        node.appendChild(
          this.element
            .querySelector("template")
            .content.firstElementChild.cloneNode(true)
        );
        this.element.appendChild(node.firstElementChild).focus();
        this.element.setAttribute("loaded", true);
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      } else {
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      }
    } else if (
      this.videoPlayer &&
      this.videoPlayer.el_.classList.contains("vjs-playing")
    ) {
      this.videoPlayer.pause();
    }
  }

  videoPlayerInitialization() {

    if (!this.element.getAttribute("loaded")) {

      const node = document.createElement("div");
      node.appendChild(
        this.element
          .querySelector("template")
          .content.firstElementChild.cloneNode(true)
      );
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute("loaded", true);
    }

    const responsive = new Responsive();
    const breakpoint = responsive.getCurrentBreakpoint();
    const isMobile = breakpoint === "phone" || breakpoint === "tablet";

    let aspect_ratio = "";
    let src = "";
    let host = "html5";

    if (isMobile) {
      aspect_ratio = this.options["aspect_mob"] || "9:16";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options["videoRatio"];
        }
        src = topQuality["url"] + "#t=0.001";
      } else if (this.options["videoType"] == "video_inside_media_external") {
        const aspectRatioHeight = Math.floor(
          100 / this.options["videom"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options["videoRatio"];
        }
        host = this.options["videom"]["host"];
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videom"]["external_id"];
        } else {
          src = this.options["videom"]["external_id"];
        }
      } else {
        if (this.options["videom"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videom"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videom"];
      }
    } else {
      aspect_ratio = this.options["aspect_desk"] || "16:9";
      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        src = topQuality["url"] + "#t=0.001";
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options["videoRatio"];
        }
      } else if (this.options["videoType"] == "video_inside_media_external") {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options["videoRatio"];
        }
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videod"]["external_id"];
        } else {
          src = this.options["videod"]["external_id"];
        }
      } else {
        if (this.options["videod"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videod"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videod"];
      }
    }

    if (!src) {
      src = "https://www.youtube.com/watch?v=_9VUPq3SxOc";
      host = "youtube";
    }
    const type =
      host === "youtube"
        ? "video/youtube"
        : host === "vimeo"
        ? "video/vimeo"
        : "video/mp4";

    aspect_ratio = aspect_ratio.replace("/", ":");
    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: false,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: this.options["controls"],
      poster: false,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      controlBar: {
        children: [
          "playToggle",
          "progressControl",
          "currentTimeDisplay",
          "timeDivider",
          "durationDisplay",
          "CustomControlSpacer",
          "VolumePanel",
          "fullscreenToggle",
        ],
      },

      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };

    const videoplayerID = this.element.querySelector("video");
    this.videoPlayer = videojs(videoplayerID, payload);

    const _this = this;
    this.videoPlayer.on("ready", function () {
      _this.element.querySelector(".videoHolder").style.display = "block";

      if (_this.trueObserver == false && _this.options["viewport"]) {
        _this.createObserver();
      }
    });

    if (this.options['muted'] && host == 'vimeo') {
      this.videoPlayer.on('play', function () {

        _this.videoPlayer.muted("true");
      })
    }

    if (this.options["controls"]) {
      if (host == 'html5' || host == "vimeo"){
      this.videoPlayer.on("touchstart", function () {
        if (event.target.closest(".vjs-control-bar")) {
          return;
        }
  
        if (_this.videoPlayer.paused()) {
          _this.videoPlayer.play();
        } else {
          _this.videoPlayer.pause();
        }
      });}
      if(host == 'html5') return;
      this.videoPlayer.on("click", function () {
        if (event.target.closest(".vjs-control-bar")) {
          return;
        }

        if (_this.videoPlayer.paused()) {
          _this.videoPlayer.play();
        } else {
          _this.videoPlayer.pause();
        }
      });
    }


  }

  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
      rootMargin: "200px 0px 200px 0px",
    });

    observer.observe(this.element);
    this.trueObserver = true;
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer) {
          this.checkLoaded();
          return;
        }

        if (this.options["viewport"] && this.videoPlayer) {
        
            this.videoPlayer.muted("true");
      
          const checkIfPlaying = () => {
          
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              this.videoPlayer.play();
              setTimeout(checkIfPlaying, 100); // Wait 100 milliseconds and check again
            }
          };

          checkIfPlaying();
        }
      } else if (
        entry.intersectionRatio === 0 ||
        entry.isIntersecting == false
      ) {
        if (
          this.videoPlayer &&
          this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        }
      }
    });
  }
}
customElements.define("video-component", VideoComponent);

class FooterComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    let responsive = new Responsive();
    let breakpoint = responsive.getCurrentBreakpoint();
    if (breakpoint == "phone" || breakpoint == "tablet") {
      // this.dropdown = new Dropdown(this.element);
    }
  }
}
customElements.define("footer-component", FooterComponent);

class ProductElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.bodyDelegate = new Delegate(document.body);
    this.carouselElement = this.element.querySelector(".mainSwiper");
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.notifyMeOverlay = this.element.querySelector(".notifyMeOverlay");
    this.carouselElementThumbs = this.element.querySelector(
      ".ProductSlider--Thumbnails"
    );

    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );

    if (this.options["slides_number"] > 1) {
      if (this.options["show_thumbnails"]) {
        this.carousel = new RevolutionSwiper(
          this.carouselElement,
          this.carouselElementThumbs
        );
      } else {
        this.carousel = new RevolutionSwiper(this.carouselElement);
      }

      this.swiper = this.carouselElement.swiper;
      this.slideNumber = this.element.querySelector(
        '[data-action="watch-slides"]'
      );
      this.slideNumber.innerHTML = this.swiper.activeIndex + 1;
    }

    this.changeImageQuality();
    this.valuesWrap = this.element.querySelectorAll(
      ".ProductOption--ValusWrapper"
    );
    var localPickup = this.element.querySelector("#LocalPickup");
    if (localPickup) {
      new Drawer(this.querySelector("#LocalPickup"));
    }
    new AddToCart(this.element);
    //new Dropdown(this.element.querySelector(".ProductInfo--Wrapper"));

    if (this.options["enable_zoom"]) {
      new RevolutionImageZoom(this.element, this.carousel);
    }

    var selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");

    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }

    if (
      this.options["variant_image_id"] &&
      this.options["show_variant_image_on_load"]
    ) {
      this.updateImage();
    }

    const ratingsLink = this.element.querySelector(".ProductInfo--RatingsLink");
    const targetElem = document.querySelector("#judgeme_product_reviews");
    if (ratingsLink && targetElem) {
      ratingsLink.style.cursor = "pointer";
      this.domDelegate.on("click", '[data-action="scroll"]', () =>
        targetElem.scrollIntoView({ behavior: "smooth" })
      );
    }

    const packageSlider = this.element.querySelector(".PackageSwiper");
    if (packageSlider) {
      new RevolutionSwiper(packageSlider);
      const packageSliderWrapper =
        packageSlider.querySelector(".swiper-wrapper");

      this.domDelegate.on(
        "pointerdown",
        '[data-action="cursor"]',
        () => {
          this.mousedown = true;
          packageSliderWrapper.style.cursor = "grabbing";
          document.body.style.cursor = "grabbing";
        },
        false
      );

      this.bodyDelegate.on("pointerup", () => {
        if (!this.mousedown) return;
        this.mousedown = false;
        packageSliderWrapper.style.cursor = "grab";
        document.body.style.cursor = "";
      });
    }

    if (this.options["sticky_atc"]) {
      this.elementToHide = this.element.querySelector(".ProductAction--Sticky");
      this.elementToHide.classList.remove("stickyPopUp");
      this.bindObserver();
    }

    window.addEventListener("DOMContentLoaded", () => {
      const intervalId = setInterval(() => {
        if (document.querySelector(".appikon-bis-inline-form-wrapper")) {
          clearInterval(intervalId);

          const sendSvg =
            '<svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.67501 17.5L19.1667 10L1.67501 2.5L1.66667 8.33333L14.1667 10L1.66667 11.6667L1.67501 17.5Z" fill="#555555"/></svg>';
          const sendButton = document.querySelector(
            "#appikon-bis-inline-form-submit"
          );
          if (sendButton) sendButton.innerHTML = sendSvg;

          const productImage = this.element
            .querySelector(".ProductSlider--ImageFirst")
            .cloneNode(true);
          const destContainer = this.element.querySelector(
            "#appikon-bis-inline-form-wrapper"
          );
          destContainer.appendChild(productImage);

          const closeButton = document.createElement("button");
          closeButton.classList.add("notifyMe--Close");
          closeButton.setAttribute("data-action", "notify-close");
          closeButton.innerHTML = `
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M10.9978 9.96635L15.9478 5.01636C16.1785 4.74696 16.163 4.34537 15.9122 4.09456C15.6614 3.84375 15.2598 3.82824 14.9904 4.05895L10.0404 9.00894L5.09045 4.05216C4.82104 3.82145 4.41945 3.83696 4.16865 4.08777C3.91784 4.33858 3.90233 4.74017 4.13304 5.00957L9.08303 9.96635L4.12625 14.9163C3.93248 15.0823 3.84807 15.3428 3.90774 15.5909C3.9674 15.8389 4.16107 16.0326 4.40911 16.0923C4.65716 16.1519 4.91771 16.0675 5.08366 15.8737L10.0404 10.9238L14.9904 15.8737C15.2598 16.1045 15.6614 16.0889 15.9122 15.8381C16.163 15.5873 16.1785 15.1857 15.9478 14.9163L10.9978 9.96635Z" fill="#555555"/>
          </svg>`;
          destContainer.appendChild(closeButton);

          this.pageOverlayElement.addEventListener(
            "click",
            this.closeNotifyPopup.bind(this)
          );

          this.domDelegate.on(
            "click",
            '[data-action="notify-open"]',
            this.openNotifyPopup.bind(this)
          );

          this.domDelegate.on(
            "click",
            '[data-action="notify-close"]',
            this.closeNotifyPopup.bind(this)
          );

          this.element.dispatchEvent(
            new CustomEvent("notify:added", {
              bubbles: true,
              detail: document.querySelectorAll(".Button--NotifyMe"),
            })
          );
        }
      }, 100);

      setTimeout(() => {
        clearInterval(intervalId);
      }, 5000);
    });

    this.bindEvents();
  }

  bindEvents() {
    this.domDelegate.on("variant:changed", this.updateImage.bind(this));

    this.domDelegate.on(
      "click",
      ".ProductAction--ChangeButton",
      this.scrollToTop.bind(this)
    );

    if (this.swiper) {
      this.swiper.on("slideChange", () => {
        this.slideNumber.innerHTML = this.swiper.realIndex + 1;
      });
    }

    this.closeNotifyPopupBinder = this.closeNotifyPopup.bind(this);
  }

  bindObserver() {
    const elementToObserve = this.element.querySelector(".ScrollToATC");
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (
          entry.isIntersecting ||
          entry.intersectionRatio == 1 ||
          elementToObserve.getBoundingClientRect().top >= window.innerHeight
        ) {
          this.elementToHide.classList.remove("stickyPopUp");
        } else {
          this.elementToHide.classList.add("stickyPopUp");
        }
      });
    });

    observer.observe(elementToObserve);
  }

  openNotifyPopup() {
    event.preventDefault();
    this.isOpen = true;

    this.notifyMeOverlay.classList.add("is-visible");
    this.domDelegate.on(
      "click",
      ".notifyMeOverlay",
      this.closeNotifyPopupBinder
    );
    bodyScrollLock.disableBodyScroll(
      document.querySelector("[data-scrollable]"),
      bodyScrollLockOptions
    );
    document
      .querySelector(".appikon-bis-inline-form-wrapper")
      .classList.add("showNotifyMe");
  }

  closeNotifyPopup() {
    event.preventDefault();
    if (!this.isOpen) return;

    this.domDelegate.off(
      "click",
      ".notifyMeOverlay",
      this.closeNotifyPopupBinder
    );
    this.notifyMeOverlay.classList.remove("is-visible");

    bodyScrollLock.enableBodyScroll(
      document.querySelector("[data-scrollable]"),
      bodyScrollLockOptions
    );
    document
      .querySelector(".appikon-bis-inline-form-wrapper")
      .classList.remove("showNotifyMe");

    this.isOpen = false;
  }

  scrollToTop() {
    const elementToScroll = this.element.querySelector(".ScrollToATC");

    if (elementToScroll) {
      const elementTop = elementToScroll.getBoundingClientRect().top;
      const positionToScroll =
        elementTop +
        window.scrollY +
        elementToScroll.clientHeight -
        window.innerHeight +
        24;

      window.scrollTo({
        top: positionToScroll,
        behavior: "smooth",
      });
    }
  }

  updateImage(event) {
    if (event) {
      var imageID = event.detail.new_image;
    } else {
      var imageID = this.options["variant_image_id"];
    }

    var selector = "#Image--" + imageID;

    var imageEl = this.element.querySelector(selector);

    if (imageEl) {
      this.slideNumber.innerHTML =
        parseInt(imageEl.getAttribute("data-position")) + 1;
      this.carousel.selectCell(parseInt(imageEl.getAttribute("data-position")));
    }

    if (imageEl) {
      this.carousel.selectCell(parseInt(imageEl.getAttribute("data-position")));
    }
  }

  changeImageQuality() {
    var imageToReveal = null;
    imageToReveal = this.element.querySelector(".ProductSlider--ImageFirst");
    if (imageToReveal !== null) {
      const replaceUrl = imageToReveal
        .getAttribute("data-src")
        .replace("{width}x", "2600x");
      imageToReveal.src = replaceUrl;
    }
  }
}
customElements.define("product-component", ProductElement);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.type = this.element.getAttribute("data-type");
    this.productID = this.element.getAttribute("data-product-id");
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.bindEvents();
    this.onQuantityChange();
  }

  bindEvents() {
    this.delegateBody.on("quantity:changed", this.onQuantityChange.bind(this));

    var selectboxes = this.element.querySelectorAll("select, input");
    selectboxes.forEach((item) => {
      item.addEventListener("change", this.onVariantChange.bind(this));
    });

    this.delegateBody.on("notify:added", this.toggleAddButton.bind(this));
  }

  onQuantityChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
    this.updatePickupAvailability();

    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select, input:checked"),
      (select) => select.value
    );

    this.checkAvailability();
  }

  checkAvailability() {
    this.element
      .querySelectorAll(`input[data-disabled="true"]`)
      .forEach((input) => (input.dataset.disabled = false));

    const mainOptionAvailabillity = {},
      secondOptionAvailabillity = {};

    this.getVariantData()?.forEach((variant) => {
      this.checkAllInstancesOfOption(
        mainOptionAvailabillity,
        variant.option1,
        variant.available
      );

      if (this.options.length > 1) {
        const checkAllButLastOne = [...this.options];
        checkAllButLastOne.pop();
        const containsAll = checkAllButLastOne.every((option) => {
          return variant.options.includes(option);
        });

        if (containsAll) {
          if (!variant.available) {
            const optionToDisable = this.findDifference(
              checkAllButLastOne,
              variant.options
            );
            this.element.querySelector(
              `input[value="${optionToDisable}"]`
            ).dataset.disabled = true;
          }
        }

        if (this.options.length > 2) {
          const checkAllButLastMultiple = [this.options[0], variant.option2];
          const containsAll = checkAllButLastMultiple.every((option) => {
            return variant.options.includes(option);
          });

          if (containsAll)
            this.checkAllInstancesOfOption(
              secondOptionAvailabillity,
              variant.option2,
              variant.available
            );
        }
      }
    });

    for (const option in mainOptionAvailabillity) {
      if (!mainOptionAvailabillity[option])
        this.element.querySelector(
          `input[value="${option}"]`
        ).dataset.disabled = true;
    }

    for (const option in secondOptionAvailabillity) {
      if (!secondOptionAvailabillity[option])
        this.element.querySelector(
          `input[value="${option}"]`
        ).dataset.disabled = true;
    }
  }

  checkAllInstancesOfOption(object, option, isAvailable) {
    // Create a new variable for the color if it doesn't exist
    if (!object[option]) {
      object[option] = isAvailable;
    } else {
      // If the color variable already exists, update it to true if the current variant is available
      if (isAvailable) {
        object[option] = true;
      }
    }
  }

  findDifference(oldArray, newArray) {
    const difference = newArray.filter(
      (newValue) => !oldArray.includes(newValue)
    );
    return difference.length > 0 ? difference : null;
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      this.options;
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const newMedia = this.currentVariant.featured_media.id;
    if (!newMedia) return;
    this.element.dispatchEvent(
      new CustomEvent("variant:changed", {
        bubbles: true,
        detail: { new_image: newMedia },
      })
    );
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.productID}, #product-form-installment`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = ".ProductInfo--Prices";
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destinations = document.querySelectorAll(id);
        const source = html.querySelector(id);

        if (source && destinations) {
          destinations.forEach((destination) => {
            destination.innerHTML = source.innerHTML;
          });
        }

        const quantityButton = document.querySelector(".QuantityHandler");
        if (quantityButton) {
          const source = html.querySelector(".QuantityHandler");
          if (source && quantityButton)
            quantityButton.innerHTML = source.innerHTML;
        }
        this.toggleAddButton();
      });
  }

  toggleAddButton(e) {
    let quantity = "";
    const addButton = document.querySelectorAll(".MainProduct--ATC"),
      addButtonInner = document.querySelectorAll(
        ".MainProduct--ATC .ButtonText"
      ),
      quantityEl = document.querySelector(".QuantitySelector__ProductQuantity");

    if (quantityEl) {
      quantity = quantityEl.value;
    }
    if (window.variantInfo.show_icon) {
      var buySvg =
        '<svg class="Svg Svg--shopping_cart mr-m" width="24" height="24" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.31 5.19547C25.1687 5.02127 24.9568 4.91946 24.7325 4.91797H9.11751L9.60501 6.41797H23.75L21.7475 15.418H10.4975L7.07001 4.56547C6.99476 4.33174 6.80986 4.14965 6.57501 4.07797L3.50001 3.13297C3.24278 3.05393 2.96292 3.11812 2.76584 3.30137C2.56877 3.48461 2.48443 3.75907 2.54459 4.02137C2.60476 4.28366 2.80028 4.49393 3.05751 4.57297L5.75001 5.39797L9.19251 16.273L7.96251 17.278L7.86501 17.3755C7.2374 18.0987 7.21221 19.1659 7.80501 19.918C8.21952 20.4221 8.84817 20.7002 9.50001 20.668H22.0175C22.4317 20.668 22.7675 20.3322 22.7675 19.918C22.7675 19.5038 22.4317 19.168 22.0175 19.168H9.38001C9.20436 19.162 9.0446 19.0646 8.95873 18.9113C8.87286 18.7579 8.87334 18.5709 8.96001 18.418L10.7675 16.918H22.3475C22.705 16.9267 23.0189 16.6818 23.0975 16.333L25.475 5.83297C25.5212 5.6064 25.4603 5.37117 25.31 5.19547ZM20.75 25.168C21.682 25.168 22.4375 24.4125 22.4375 23.4805C22.4375 22.5485 21.682 21.793 20.75 21.793C19.818 21.793 19.0625 22.5485 19.0625 23.4805C19.0625 24.4125 19.818 25.168 20.75 25.168ZM12.185 23.4805C12.185 24.4125 11.4295 25.168 10.4975 25.168C9.56553 25.168 8.81001 24.4125 8.81001 23.4805C8.81001 22.5485 9.56553 21.793 10.4975 21.793C11.4295 21.793 12.185 22.5485 12.185 23.4805Z" fill="#121212"></path></svg>';
    } else {
      var buySvg = "";
    }

    if (!addButton) return;

    if (!quantity) {
      quantity = 1;
    }

    if (e) this.notifyMeButtons = e.detail;

    const stockWatcher = document.querySelector(
      ".ProductInfo--StockAvailability"
    );
    if (this.currentVariant.available == false) {
      if (stockWatcher)
        stockWatcher.innerHTML = window.variantStrings.outOfStock;
      if (!this.notifyMeButtons) {
        if (this.notifyMeButtons)
          this.notifyMeButtons.forEach((btn) => (btn.style.display = "none"));
        addButton.forEach((btn) => (btn.style.display = "flex"));
      } else {
        addButton.forEach((btn) => (btn.style.display = "none"));
        this.notifyMeButtons.forEach((btn) => (btn.style.display = "flex"));
      }
      addButton.forEach((btn) => {
        btn.setAttribute("disabled", "disabled");
        btn.classList.add("ProductCard--Sold__Out");
      });
      addButtonInner.forEach((btn) => {
        btn.innerHTML = buySvg + window.variantStrings.soldOut;
      });
    } else {
      if (stockWatcher) stockWatcher.innerHTML = window.variantStrings.inStock;
      addButton.forEach((btn) => (btn.style.display = "flex"));
      if (this.notifyMeButtons)
        this.notifyMeButtons.forEach((btn) => (btn.style.display = "none"));
      addButton.forEach((btn) => {
        btn.removeAttribute("disabled");
        btn.classList.remove("ProductCard--Sold__Out");
      });
      if (window.variantInfo.show_price) {
        var priceElement =
          "<span class='u-pb1 mainProductPrice'>&nbsp;" +
          Shopify.formatMoney(
            this.currentVariant.price * quantity,
            window.theme.moneyFormat
          );
        +"</span>";
      } else {
        var priceElement = "";
      }

      addButtonInner.forEach(
        (btn) =>
          (btn.innerHTML =
            buySvg + window.variantStrings.addToCartFor + priceElement)
      );
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class BlogSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.articles = this.element.querySelectorAll(".BlogArticle");
    this.articleContainer = this.element.querySelector(".BlogArticle--Wrapper");
  }
}
customElements.define("blog-section", BlogSection);

class SearchBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    new AddToCart(this.element);
    this.searchInputElement = this.element.querySelector('[name="q"]');

    this.searchResultsElement = this.element.querySelector(".searchWrapper");
    this.pageOverlayElement = this.element.querySelector(".sectionOverlay");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.initialSearchLayout = this.searchResultsElement.cloneNode(true);
    this.clearSearchButton = this.element.querySelector(".searchInput--clear");
    this.recentSearchesWrapper = this.element.querySelector(
      "#predictiveSearch--recentSearches"
    );
    if (window.theme.showRecentSearches) {
      this.getRecentSearches();
    }
    this.headerTransparent = false;
    if (new Responsive().matchesBreakpoint("lap-and-up")) {
      this.carouselElement = this.element.querySelector(".searchInitialView");
      if (this.carouselElement) {
        this.carousel = new RevolutionSwiper(this.carouselElement);
      }
    }

    document.documentElement.style.setProperty(
      "--search-header-height",
      `${this.searchInputElement.offsetHeight + 48}px`
    );

    this.bindEvents();
  }

  bindEvents() {
    this._onInputListener = this.debounce(this.onInput.bind(this), 450);

    this.delegateBody.on(
      "click",
      '[data-action="open-search"]',
      this.openSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="clear-input"]',
      this.resetSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-search"]',
      this.closeSearch.bind(this)
    );

    this.searchInputElement.addEventListener("input", this._onInputListener);

    this.delegateElement.on(
      "click",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );

    this.delegateElement.on(
      "keypress",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );
    this.delegateBody.on("menu:open", this.closeSearch.bind(this));
    this.delegateBody.on("close:search", this.closeSearch.bind(this));
  }

  initCarousel() {
    if (new Responsive().matchesBreakpoint("lap-and-up")) {
      var carousel = this.searchResultsElement.querySelector(
        "[data-swiper-settings]"
      );
      if (carousel) {
        this.newCarousel = new RevolutionSwiper(carousel);
      }
    }
  }

  debounce(fn, delay) {
    var _this0 = this;

    var timer = null;

    return function () {
      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timer);

      timer = setTimeout(function () {
        fn.apply(_this0, args);
      }, delay);
    };
  }

  openSearch(event) {
    event.preventDefault();

    const _this = this;
    // Check if search is already open, close it if true
    if (this.isOpen) {
      this.closeSearch();
      return;
    }

    this.element.dispatchEvent(
      new CustomEvent("menu:close", { bubbles: true })
    );

    // Check if search element exists
    if (!this.element) {
      console.error("Search element not found");
      return;
    }

    document.querySelector("#header").classList.add("search-opened");

    // Show search element and page overlay
    const search = document.querySelector("#quickSearch");
    if (search) {
      search.setAttribute("aria-hidden", false);
    }
    this.pageOverlayElement.classList.add("is-visible");
    // Disable scrolling on body
    document.body.classList.add("scrollLock");
    bodyScrollLock.disableBodyScroll(
      this.element.querySelector("[data-scrollable]"),
      bodyScrollLockOptions
    );

    // Focus on search input element after delay
    setTimeout(() => {
      if (_this.searchInputElement) {
        _this.searchInputElement.focus();
      }
    }, 200);

    if (document.querySelector(".Header--Transparent")) {
      setTimeout(() => {
        const header = document.body.querySelector("#header");
        if (header) {
          header.classList.remove("Header--Transparent");
        }
      }, 15);
      this.headerTransparent = true;
    }

    // Set isOpen to true
    this.isOpen = true;

    // Add event listener to page overlay to close search
    if (this.pageOverlayElement) {
      this.closeListener = this.closeSearch.bind(this);
      this.pageOverlayElement.addEventListener("click", this.closeListener);
    }
  }

  closeSearch() {
    event.preventDefault();

    if (!this.isOpen) {
      return;
    }
    document.body.classList.remove("scrollLock");
    bodyScrollLock.enableBodyScroll(
      this.element.querySelector("[data-scrollable]"),
      bodyScrollLockOptions
    );
    this.element.setAttribute("aria-hidden", true);
    const transitionElement = this.element.querySelector(".searchInnerWrapper");

    document.querySelector("#header").classList.remove("search-opened");

    const transitionEndHandler = () => {
      if (this.headerTransparent && this.headerTransparent) {
        document.body
          .querySelector("#header")
          .classList.add("Header--Transparent");
      }
      transitionElement.removeEventListener(
        "transitionend",
        transitionEndHandler
      );
    };

    transitionElement.addEventListener("transitionend", transitionEndHandler);

    this.pageOverlayElement.classList.remove("is-visible");

    this.isOpen = false;
  }

  async onInput(event) {
    if (this.recentSearchesWrapper)
      this.recentSearchesWrapper.style.display = "none";
    this.allPredictiveSearchInstances = [];
    this.lastInputValue = event.target.value;
    this.searchResultsElement = this.element.querySelector(".searchWrapper");
    this.searchResultsElement.style.opacity = 0;
    this.clearSearchButton.setAttribute("aria-hidden", "false");
    if (event.target.getAttribute("data-value") && this.lastInputValue === 0) {
      this.lastInputValue = event.target.getAttribute("data-value");
      const el = this.element.querySelector(".searchInput");

      el.setAttribute("value", this.lastInputValue);
      el.value = this.lastInputValue;
    } else {
      if (this.lastInputValue === "") {
        this.initialSearchLayout.style.opacity = 0;
        this.resetSearch();
        return;
      }
    }

    try {
      const response = await fetch(
        `${routes.predictive_search_url}?q=${encodeURIComponent(
          this.lastInputValue
        )}&resources[limit_scope]=each&section_id=search-predictive`
      );

      if (!response.ok) {
        var error = new Error(response.status);
        throw error;
      }

      const text = await response.text();
      const resultsMarkup = new DOMParser()
        .parseFromString(text, "text/html")
        .querySelector("#shopify-section-search-predictive").innerHTML;

      // Save bandwidth keeping the cache in all instances synced
      this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
        predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
      });
      const div = document.createElement("div");
      div.innerHTML = resultsMarkup;

      const suggestedQueries = div.querySelector("template");
      const currentSuggestedQueries = this.element.querySelector(
        ".predictiveSearch--queries"
      );
      const currentRecentQueris = this.element.querySelector(
        "#predictiveSearch--recentSearches"
      );

      this.searchResultsElement.innerHTML = resultsMarkup;

      if (suggestedQueries) {
        if (currentRecentQueris) {
          currentRecentQueris.remove();
        }

        if (currentSuggestedQueries) {
          currentSuggestedQueries.remove();
        }
        const node = suggestedQueries.content.firstElementChild.cloneNode(true);
        this.searchResultsElement.prepend(node);
      }

      if (window.theme.showRecentSearches) {
        if (!suggestedQueries) this.getRecentSearches();
        this.recentSearches();
      }

      this.initCarousel();

      this.searchResultsElement.style.opacity = 1;
    } catch (error) {
      if (error?.code === 20) {
        // Code 20 means the call was aborted
        return;
      }

      throw error;
    }
  }

  resetSearch() {
    if (this.recentSearchesWrapper)
      this.recentSearchesWrapper.style.display = "block";
    this.searchResultsElement.innerHTML = this.initialSearchLayout.innerHTML;
    const currentSuggestedQueries = this.element.querySelector(
      ".predictiveSearch--queries"
    );
    if (currentSuggestedQueries) currentSuggestedQueries.remove();
    this.searchInputElement.value = "";
    this.searchInputElement.removeAttribute("value");

    if (window.theme.showRecentSearches) {
      this.getRecentSearches();
    }
    this.initCarousel();
    this.searchResultsElement.style.opacity = 1;
    this.clearSearchButton.setAttribute("aria-hidden", "true");
  }

  recentSearches() {
    if (this.lastInputValue.length > 3) {
      var searchTerm = JSON.parse(localStorage.getItem("searchTerms") || "[]");
      if (!searchTerm.includes(this.lastInputValue)) {
        searchTerm.unshift(this.lastInputValue);
      }

      // Then, we save the search info into the local storage, by keeping only the 5 most recent
      try {
        localStorage.setItem(
          "searchTerms",
          JSON.stringify(searchTerm.slice(0, 5))
        );
      } catch (error) {}
    }
  }

  getRecentSearches() {
    let appendString = "";
    const items = JSON.parse(localStorage.getItem("searchTerms") || "[]");
    let elementToAdd = this.element.querySelector(".search--recentResults");
    if (items.length > 0) {
      items.forEach((id) => {
        appendString =
          appendString +
          "<li role='option' tabIndex='0' class='u-p3' data-action='search-string' data-value='" +
          id +
          "'>" +
          id +
          "</li>";
      });

      elementToAdd.innerHTML = appendString;
    } else {
      this.querySelector("#predictiveSearch--recentSearches").style.display =
        "none";
    }
  }
}
customElements.define("search-bar", SearchBar);

class ContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );
  }

  toggleButton() {
    this.buttonState = true;

    var allBoxes = this.element.querySelectorAll("[data-state='required']");
    allBoxes.forEach((item, i) => {
      if (item.checked == false) {
        this.buttonState = false;
      }
    });
    if (this.buttonState == true) {
      this.element.querySelector(".Contact-Btn").removeAttribute("disabled");
    } else {
      this.element.querySelector(".Contact-Btn").setAttribute("disabled", true);
    }
  }
}

customElements.define("contact-section", ContactSection);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
    };
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define("localization-form", LocalizationForm);

class PickupAvailability extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (!this.hasAttribute("available")) return;
    this.fetchAvailability(this.dataset.variantId);
  }

  fetchAvailability(variantId) {
    const variantSectionUrl = `${window.routes.localeRootUrl}/variants/${variantId}/?section_id=helper-pickup`;

    fetch(variantSectionUrl)
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector(".shopify-section");
        this.renderPreview(sectionInnerHTML);
      })
      .catch((e) => {
        this.renderError();
      });
  }

  renderError() {}

  renderPreview(sectionInnerHTML) {
    this.element.innerHTML = "";

    this.element.appendChild(
      sectionInnerHTML.querySelector(".LocalPickup_--Wrapper")
    );
    if (sectionInnerHTML.querySelector("#LocalPickup")) {
      this.element.appendChild(sectionInnerHTML.querySelector("#LocalPickup"));
      new Drawer(this.element.querySelector("#LocalPickup"));
    }
  }
}

customElements.define("pickup-availability", PickupAvailability);

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.textarea = this.element.querySelector("textarea");
    this.button = this.element.querySelector(".CartNote--Submit");
    this.noteSucess = this.element.querySelector(".cartNote--Success");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action='update-note']",
      this.updateNote.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action='edit-note']",
      this.editNote.bind(this)
    );
  }
  editNote() {
    this.textarea.removeAttribute("disabled");
    this.button.innerText = window.cartStrings.enter_note;
    this.button.setAttribute("data-action", "update-note");
    this.textarea.focus();
    this.noteSucess.style.visibility = "hidden";
    this.noteSucess.style.opacity = "0";
    this.noteSucess.style.display = "none";
  }

  updateNote() {
    var _this = this;
    this.value = this.textarea.value;

    fetch(window.routes.localeRootUrl + "/cart/update.js", {
      body: JSON.stringify({ note: this.value }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (_this.value == "") {
          return;
        }
        _this.textarea.setAttribute("disabled", "disabled");
        _this.button.innerText = window.cartStrings.note_change;
        _this.button.setAttribute("data-action", "edit-note");
        _this.noteSucess.style.visibility = "visible";
        _this.noteSucess.style.opacity = "1";
        _this.noteSucess.style.display = "flex";
      }
    });
  }
}

customElements.define("cart-note", CartNote);

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );

    if (this.options.edit_mode) {
      this.options.delay = 0;
      this.openNewsletter();
    } else {
      this.handleOpenOptions();
    }

    if (
      window.location.href.indexOf("form_type=customer#popupForm") > -1 ||
      window.location.href.indexOf("customer_posted=true#popupForm") > -1 ||
      window.location.href.indexOf("customer_posted=true#nsltForm*") > -1
    ) {
      this.options.delay = 0;
      this.openNewsletter();
    }
  }

  handleOpenOptions() {
    const localKey = localStorage.getItem("popup-seen");

    if (this.options.show_only_once && localKey === "true") return;

    if (this.options.scroll_amount > 0) {
      document.addEventListener("scroll", this.scrollListener);
    } else {
      this.openNewsletter();
    }
  }

  scrollListener = () => {
    const body = document.body;
    const html = document.documentElement;

    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    const percScrolled = (window.scrollY / docHeight) * 100;

    if (percScrolled >= this.options.scroll_amount) {
      this.openNewsletter();
    }
  };

  openNewsletter() {
    document.removeEventListener("scroll", this.scrollListener);

    if(!new Responsive().matchesBreakpoint('lap-and-up')) {
      bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);
      document.body.classList.add("scrollLock");
    }

    setTimeout(() => {
      this.element.setAttribute("aria-hidden", false);

      localStorage.setItem("popup-seen", true);

      this.delegateElement.on(
        "click",
        '[data-action="close-modal"]',
        this.closeNewsletter
      );
    }, 1000 * this.options.delay);
  }

  closeNewsletter = () => {
    this.element.setAttribute("aria-hidden", true);
    document.removeEventListener("scroll", this.scrollListener);
    if(!new Responsive().matchesBreakpoint('lap-and-up')) {
      bodyScrollLock.clearAllBodyScrollLocks();
      document.body.classList.remove("scrollLock");
    }
  };
}

customElements.define("newsletter-popup", NewsletterPopup);

class AccountHandler extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.drawer = new Drawer(this.element.querySelector("#accountDrawer"));
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="toggle-tab"]',
      this.toggleTab.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="submit-login"]',
      this.submitLogin.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="submit-register"]',
      this.submitRegistration.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="toggle-recovery"]',
      this.toggleRecovery.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="submit-recovery"]',
      this.accountRecover.bind(this)
    );

    this.delegateElement.on(
      "keypress",
      '[data-action="submit-input-login"]',
      this.accountInputSubmit.bind(this)
    );
    this.delegateElement.on(
      "keypress",
      '[data-action="submit-input-reg"]',
      this.accountInputSubmitReg.bind(this)
    );
    this.delegateElement.on(
      "keypress",
      '[data-action="submit-input-forgot-pass"]',
      this.accountInputSubmitForgot.bind(this)
    );
  }

  toggleRecovery() {
    event.preventDefault();
    const id = event.target.dataset.id;

    if (id == "recoverFlex") {
      this.element
        .querySelector("#recoverFlex")
        .setAttribute("aria-visible", "true");
      this.element
        .querySelector("#loginFlex")
        .setAttribute("aria-visible", "false");
      this.element
        .querySelector("#registerFlex")
        .setAttribute("aria-visible", "false");
    } else if (id == "registerFlex") {
      this.element
        .querySelector("#recoverFlex")
        .setAttribute("aria-visible", "false");
      this.element
        .querySelector("#loginFlex")
        .setAttribute("aria-visible", "false");
      this.element
        .querySelector("#registerFlex")
        .setAttribute("aria-visible", "true");
    } else {
      this.element
        .querySelector("#recoverFlex")
        .setAttribute("aria-visible", "false");
      this.element
        .querySelector("#registerFlex")
        .setAttribute("aria-visible", "false");
      this.element
        .querySelector("#loginFlex")
        .setAttribute("aria-visible", "true");
    }
  }

  accountInputSubmit(event) {
    if (event.key === "Enter") this.submitLogin(event);
  }
  accountInputSubmitReg(event) {
    if (event.key === "Enter") this.submitRegistration(event);
  }
  accountInputSubmitForgot(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.accountRecover(event);
    }
  }

  accountRecover(event) {
    event.preventDefault();

    const _this = this;
    const registrationEndpoint = "/account/recover";
    event.target.querySelector(".itemLoader")?.classList.add("is-visible");

    // Create the request body with the registration data
    const requestBody = {
      email: this.element.querySelector("#RecoverEmail").value,
    };

    // Send the AJAX request
    (async function () {
      try {
        const response = await fetch(registrationEndpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });

        const responseText = await response.text();
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = responseText;

        if (responseText.indexOf("RecoverEmail-email-error") !== -1) {
          _this.element.querySelector(
            "#recoverFlex .accountDrawer--SuccessSpace"
          ).innerHTML = "";
          _this.element.querySelector(
            "#recoverFlex .accountDrawer--ErrorSpace"
          ).innerHTML =
            '<span class="pb-s u-p4">' +
            tempDiv.querySelector("#RecoverEmail-email-error").innerHTML +
            "</span>";
        } else if (responseText.indexOf("recoverSuccess") !== -1) {
          _this.element.querySelector(
            "#recoverFlex .accountDrawer--ErrorSpace"
          ).innerHTML = "";
          _this.element.querySelector(
            "#recoverFlex .accountDrawer--SuccessSpace"
          ).innerHTML =
            '<span class="pb-s u-p4">' +
            tempDiv.querySelector("#recoverSuccess").innerHTML +
            "</span>";
        }
        event.target.querySelector(".itemLoader")?.classList.remove("is-visible");
      } catch (error) {
        console.log(
          "An error occurred during the registration request:",
          error
        );
      }
    })();
  }

  submitRegistration(event) {
    event.preventDefault();
    const _this = this;
    const registrationEndpoint = "/account";
    event.target.querySelector(".itemLoader")?.classList.add("is-visible");
    // Create the request body with the registration data
    const requestBody = {
      customer: {
        first_name: this.element.querySelector("#RegisterForm-FirstName").value,
        last_name: this.element.querySelector("#RegisterForm-LastName").value,
        email: this.element.querySelector("#RegisterForm-email").value,
        password: this.element.querySelector("#RegisterForm-password").value,
      },
    };

    // Send the AJAX request
    (async function () {
      try {
        const response = await fetch(registrationEndpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });

        const responseText = await response.text();

        if (responseText.indexOf("registerErrors") !== -1) {
          console.log("Error occurred during registration");
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = responseText;

          const emailError = tempDiv.querySelector("#RegisterForm-email-error");
          const passwordError = tempDiv.querySelector(
            "#RegisterForm-password-error"
          );

          if (emailError)
            _this.element.querySelector(
              "#RegisterForm-email-error"
            ).innerHTML = `<div class="AlertErrorInner u-p4 pb-s">${
              tempDiv.querySelector("#RegisterForm-email-error").innerHTML
            }</div>`;
          if (passwordError)
            _this.element.querySelector(
              "#RegisterForm-password-error"
            ).innerHTML = `<div class="AlertErrorInner u-p4 pb-s">${
              tempDiv.querySelector("#RegisterForm-password-error").innerHTML
            }</div>`;
        } else {
          location.href = window.routes.account_url;
        }
        event.target.querySelector(".itemLoader")?.classList.remove("is-visible");
      } catch (error) {
        console.log(
          "An error occurred during the registration request:",
          error
        );
        itemLoader?.classList.remove('is-visible');
      }
    })();
  }

  submitLogin(event) {
    event.preventDefault();
    const _this = this;
    const loginEndpoint = "/account/login";
    event.target.querySelector(".itemLoader")?.classList.add("is-visible");

    // Create the request body with the login credentials
    const requestBody = {
      customer: {
        email: this.element.querySelector("#customer_login #CustomerEmail")
          .value,
        password: this.element.querySelector(
          "#customer_login #CustomerPassword"
        ).value,
      },
    };

    // Send the AJAX request
    (async function () {
      try {
        const response = await fetch(loginEndpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });

        const responseText = await response.text();

        if (responseText.indexOf("formError") !== -1) {
          console.log("Incorrect email or password");
          const tempDiv = document.createElement("div");

          tempDiv.innerHTML = responseText;

          _this.element.querySelector(
            "#login .accountDrawer--ErrorSpace"
          ).innerHTML = `<div class="AlertErrorInner u-p4 pb-s">${
            tempDiv.querySelector(".AlertError").innerHTML
          }</div>`;

          event.target.querySelector(".itemLoader")?.classList.remove("is-visible");
        } else {
          location.href = window.routes.account_url;
        }
      } catch (error) {
        console.log("An error occurred during the login request:", error);
      }
    })();
  }

  toggleTab(event) {
    const id = event.target.dataset.id;
    const allTabs = this.element.querySelectorAll(
      '.accountDrawer--Tab[aria-expanded="true"]'
    );
    const allContent = this.element.querySelectorAll(".accountContent");

    allTabs.forEach((tab) => {
      tab.setAttribute("aria-expanded", "false");
    });

    event.target.setAttribute("aria-expanded", "true");

    allContent.forEach((content) => {
      content.setAttribute("aria-visible", "false");
    });

    const content = this.element.querySelector(`#${id}`);
    if (content) {
      content.setAttribute("aria-visible", "true");
    }
  }
}

customElements.define("account-handler", AccountHandler);

class LocalizationSelectors extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    let responsive = new Responsive();
    let breakpoint = responsive.getCurrentBreakpoint();
    var selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    var location = this.element.getAttribute("data-settings");

    if (location == "sidebarMenu") {
      var additionalOverlay = true;
    } else {
      var additionalOverlay = false;
    }
    if (breakpoint != "phone" && breakpoint != "tablet") {
      if (selectBoxes.length > 0) {
        selectBoxes.forEach((item, i) => {
          new RevolutionSelectbox(item);
        });
      }
    } else {
      if (selectBoxes.length > 0) {
        selectBoxes.forEach((item, i) => {
          new RevolutionSelectbox(item, true, additionalOverlay);
        });
      }
    }
  }
}
customElements.define("localization-selectors", LocalizationSelectors);

function compareArrays(oldArray, newArray) {
  let id;

  localStorage.setItem('newCartState', JSON.stringify(newArray));

  oldArray.forEach((oldItem) => {
    const newItem = newArray.find((item) => item.id === oldItem.id);

    if (!newItem) {
      id = oldItem.id;
    } else if (oldItem.quantity !== newItem.quantity) {
      id = oldItem.id;
    }
  });

  newArray.forEach((newItem) => {
    const oldItem = oldArray.find((item) => item.id === newItem.id);

    if (!oldItem) {
      id = newItem.id;
    }
  });

  document.body.dispatchEvent(
    new CustomEvent("product:changed", {
      bubbles: true,
      detail: id
    })
  );
}
class ProductCard extends HTMLElement {
  constructor(elem) {
    super();
    elem ? (this.element = elem) : (this.element = this);
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.quantityHandler = this.element.querySelector(
      ".productCard--QuantityHandler"
    );
    this.quantityHandlerInput = this.quantityHandler.querySelector("input");
    this.max = parseInt(this.quantityHandlerInput.max);
    this.addButton = this.quantityHandler.querySelector(
      '[data-quantity="plus"]'
    );

    this.form = this.element.querySelector("form[data-productid]");
    this.addSubButton = this.form.querySelector(".ProductCard--instantATC");
    this.sub = this.addSubButton.classList.contains("AddToCartSub");
    this.variantId = this.form.dataset.variantid;
    new AddToCart(this.form);

    this.productMediaSlider = this.element.querySelector(
      ".ProductCard--MediaSlider"
    );
    if (this.productMediaSlider) {
      const productId = this.productMediaSlider.getAttribute("data-id");
      new Swiper(this.productMediaSlider, {
        slidesPerView: "auto",
        spaceBetween: 0,
        preloadImages: false,
        resistanceRatio: 0,
        autoHeight: false,
        hashNavigation: {
          watchState: true,
          replaceState: true
        },
        navigation: {
          nextEl: `.swiperNextId--${productId}`,
          prevEl: `.swiperPrevId--${productId}`,
        },
      });

      const slidesNum = this.productMediaSlider.swiper.slides.length;
      if(new Responsive().matchesBreakpoint("lap-and-up") && slidesNum > 2) {
        this.productMediaSlider.classList.add("noSwipe");
      } else if (!new Responsive().matchesBreakpoint("lap-and-up")) {
        this.productMediaSlider.classList.add("noSwipe");
      }
    }

    this.showQuantityHandler();
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on("click", '[data-action="no-redirect"]', (e) =>
      e.preventDefault()
    );
    this.delegateElement.on("keydown", '[data-action="no-redirect"]', (e) => {
      if (e.keyCode === 13) {
        e.preventDefault();
        e.stopPropagation();
        this.updateItemQuantity();
      }
    });
    this.delegateElement.on(
      "click",
      '[data-action="update-product-quantity"]',
      this.updateItemQuantity.bind(this)
    );
    this.delegateElement.on(
      "change",
      'input[data-action="change-product-quantity"]',
      this.updateItemQuantity.bind(this)
    );
    this.delegateBody.on(
      "product:changed",
      this.showQuantityHandler.bind(this)
    );
  }

  updateItemQuantity(e) {
    event.preventDefault();

    var target;
    if (e) target = e.target.closest("[data-target]");
    else
      target = this.element.querySelector(
        '[data-action="change-product-quantity"]'
      );

    var quantity = parseInt(this.quantityHandlerInput.value);
    if (target.tagName === "INPUT") {
      quantity = this.quantityHandlerInput.value;
    } else if (target.dataset.quantity == "plus") {
      if (!this.atc) return;
      quantity = quantity + 1;
    } else if (target.dataset.quantity == "minus") {
      quantity = quantity - 1;
    }
    quantity = this.disableAddQuantityButton(quantity);

    fetch(window.routes.localeRootUrl + "/cart/change.js", {
      body: JSON.stringify({
        id: target.dataset.id,
        quantity: quantity,
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then((response) => {
      if (response.ok) {
        this.element.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: { onlyRender: true },
          })
        );      
        response.json().then(function (cartData) {
          const newArray = cartData.items.map(item => ({
            id: item.id,
            quantity: item.quantity
          }));   

          if(localStorage.getItem('oldCartState')) {
            compareArrays(JSON.parse(localStorage.getItem('oldCartState')), newArray);
          }
          localStorage.setItem('oldCartState', JSON.stringify(newArray));
        });
      }
    });
  }

  disableAddQuantityButton(quantity) {
    if (this.max) {
      const disable = parseInt(quantity) >= this.max;
      if (disable) {
        quantity = this.max;
        this.addButton.classList.add("disableAddQuantityButton");
        this.addButton.setAttribute(
          "data-tooltip",
          window.cartStrings.out_of_stock
        );
        this.atc = false;
        return quantity;
      } else {
        this.atc = true;
        this.addButton.classList.remove("disableAddQuantityButton");
        this.addButton.removeAttribute("data-tooltip");
      }
    }

    return quantity;
  }

  showQuantityHandler(e) {
    if (this.element.classList.contains("noQuantityButton") || this.sub) return;
    if(e && e.type == 'product:changed' && e.detail != this.variantId) return;

    var cartStateString = localStorage.getItem('newCartState');
    if(!cartStateString) cartStateString = localStorage.getItem('oldCartState');
    if (!cartStateString) return;

    const cartState = JSON.parse(cartStateString);
    let quantityAdded = cartState.find(obj => obj.id == this.variantId)?.quantity;

    if (!quantityAdded) quantityAdded = 0;
    this.quantityHandlerInput.value = quantityAdded;

    if (quantityAdded > 0) {
      this.quantityHandler.style.display = "block";
      this.form.style.display = "none";
      this.disableAddQuantityButton(quantityAdded);
    } else {
      this.quantityHandler.style.display = "none";
      this.form.style.display = "block";
    }
  }
}
customElements.define("product-card", ProductCard);

class SubscriptionFlow extends HTMLElement {
  constructor(element) {
    super();
    element ? (this.element = element) : (this.element = this);
    this.delegateElement = new Delegate(this.element);
    this.quantityButton = document.querySelector(".QuantityHandler");
    this.subscriptionSelect = this.element.querySelector(
      ".Product--SubscriptionSelect"
    );
    if(!this.element.classList.contains("main")) this.sellingPlanInput = this.element.querySelector("#selling_plan");
    else this.sellingPlanInput = document.querySelector("#selling_plan_main");
    
    this.skip = this.element.dataset.action;
    this.discountElems = this.element.querySelectorAll(
      ".Product--VisualDiscount"
    );
    this.discountParent = this.element.querySelector(
      ".Product--SubscriptionDiscount"
    );
    this.mainProductPrices = document.querySelectorAll(".mainProductPrice");

    this.updateDiscount();
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="subscription-change"]',
      this.toggleSubscription.bind(this)
    );
    this.delegateElement.on(
      "change",
      ".Product--SubscriptionSelect",
      this.toggleSelectSubscription.bind(this)
    );
  }

  updateDiscount() {
    const discount =
      this.subscriptionSelect.options[this.subscriptionSelect.selectedIndex]
        .dataset.discount;
    this.discountElems.forEach((elem) => {
      if (discount > 0) {
        if (elem.classList.contains("noHide"))
          elem.style.visibility = "visible";
        else elem.style.display = "inline";
        elem.innerHTML = " " + discount + "%";
        if (this.discountParent)
          this.discountParent.style.visibility = "visible";
      } else {
        if (elem.classList.contains("noHide")) elem.style.visibility = "hidden";
        else elem.style.display = "none";
        if (this.discountParent)
          this.discountParent.style.visibility = "hidden";
      }
    });
  }

  toggleSelectSubscription(e) {
    this.atcPrice = document.querySelectorAll(
      `.ProductForm--SubscriptionPrice[data-productid="${this.element.dataset.productid}"]`
    );
    this.selectPrice = document.querySelectorAll(
      `.Product--SubscriptionPrice[data-productid="${this.element.dataset.productid}"]`
    );

    var plan;
    if (e) plan = e.target.options[e.target.selectedIndex].dataset.plan;
    else
      plan =
        this.subscriptionSelect.options[this.subscriptionSelect.selectedIndex]
          .dataset.plan;

    if (this.sellingPlanInput) this.sellingPlanInput.value = plan;
    else document.querySelector("#selling_plan_drawer");
    this.atcPrice.forEach(
      (price) =>
        (price.innerHTML =
          this.subscriptionSelect.options[
            this.subscriptionSelect.selectedIndex
          ].dataset.price)
    );
    this.selectPrice.forEach(
      (price) =>
        (price.innerHTML =
          this.subscriptionSelect.options[
            this.subscriptionSelect.selectedIndex
          ].dataset.price)
    );

    this.mainProductPrices.forEach(
      (priceEl) =>
        (priceEl.innerHTML =
          "&nbsp;" +
          this.subscriptionSelect.options[this.subscriptionSelect.selectedIndex]
            .dataset.price)
    );
    this.updateDiscount();
  }

  //toggles between selected subscription
  toggleSubscription(e) {
    e.preventDefault();

    const oneTimeButton = this.element.querySelector(
      ".Product--SubscriptionOneTimeButton"
    );
    const subscriptionButton = this.element.querySelector(
      ".Product--SubscriptionButton[aria-selected='true']"
    );

    if (!oneTimeButton && !subscriptionButton) return;

    const parentElement = e.target.closest(".Product--SubscriptionOption");

    const updateSubs = document.querySelectorAll('[data-action="subs-update"]');
    updateSubs.forEach(
      (box) =>
        (box.innerHTML = parentElement.querySelector(
          ".Product--SubscriptionName"
        ).innerHTML)
    );

    this.mainProductPrices.forEach(
      (priceEl) =>
        (priceEl.innerHTML =
          "&nbsp;" +
          this.subscriptionSelect.options[this.subscriptionSelect.selectedIndex]
            .dataset.price)
    );

    if (parentElement.dataset.value === "one_time") {
      if (this.quantityButton)
        this.quantityButton.setAttribute("disabled", "false");

      if (!this.skip) {
        if (subscriptionButton) {
          subscriptionButton.querySelector(
            ".Product--SubscriptionCheckbox"
          ).style.display = "block";
          subscriptionButton.querySelector(
            ".Product--SubscriptionCheckboxChecked"
          ).style.display = "none";
        }

        oneTimeButton.querySelector(
          ".Product--SubscriptionCheckbox"
        ).style.display = "none";
        oneTimeButton.querySelector(
          ".Product--SubscriptionCheckboxChecked"
        ).style.display = "block";
      }

      oneTimeButton.setAttribute("aria-selected", "true");
      if (subscriptionButton)
        subscriptionButton.setAttribute("aria-selected", "false");

      var sellingPlanInput = this.element.querySelector("#selling_plan");
      if (!sellingPlanInput)
        sellingPlanInput = document.querySelector("#selling_plan_drawer");
      sellingPlanInput.value = "";
    } else if (parentElement.dataset.value !== "one_time") {
      if (this.quantityButton)
        this.quantityButton.setAttribute("disabled", "true");

      if (!this.skip) {
        if (subscriptionButton) {
          subscriptionButton.querySelector(
            ".Product--SubscriptionCheckbox"
          ).style.display = "block";
          subscriptionButton.querySelector(
            ".Product--SubscriptionCheckboxChecked"
          ).style.display = "none";
        }

        oneTimeButton.querySelector(
          ".Product--SubscriptionCheckbox"
        ).style.display = "block";
        oneTimeButton.querySelector(
          ".Product--SubscriptionCheckboxChecked"
        ).style.display = "none";

        parentElement.querySelector(
          ".Product--SubscriptionCheckbox"
        ).style.display = "none";
        parentElement.querySelector(
          ".Product--SubscriptionCheckboxChecked"
        ).style.display = "block";
      }

      if (subscriptionButton)
        subscriptionButton.setAttribute("aria-selected", "false");

      oneTimeButton.setAttribute("aria-selected", "false");
      parentElement.setAttribute("aria-selected", "true");

      this.toggleSelectSubscription();
    }
  }
}
customElements.define("subscription-flow", SubscriptionFlow);

class SubscriptionDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.drawer = new Drawer(this.element.querySelector("#subscriptionDrawer"));
    this.domDelegate = new Delegate(document.body);
    this.drawerContent = this.element.querySelector(".Drawer--Content");
    this.bindEvents();
  }

  bindEvents() {
    this.domDelegate.on("sub:opened", this.replaceContent.bind(this));
  }

  replaceContent(e) {
    const productId = e.detail.product;

    const subOptions = document.querySelector(
      `.cardInformation subscription-flow[data-productid="${productId}"]`
    );
    const subForm = document.querySelector(
      `.cardInformation form[data-productid="${productId}"]`
    );

    if (subOptions && subForm) {
      while (this.drawerContent.firstChild) {
        this.drawerContent.removeChild(this.drawerContent.firstChild);
      }

      const optionsClone = subOptions.cloneNode(true);
      const formClone = subForm.cloneNode(true);
      const sellingPlanInput = optionsClone.querySelector("#selling_plan");

      sellingPlanInput.id = sellingPlanInput.id + "_drawer";
      sellingPlanInput.removeAttribute("form");
      formClone.setAttribute("id", formClone.getAttribute("id") + "_drawer");
      formClone.appendChild(sellingPlanInput);

      this.drawerContent.appendChild(optionsClone);
      this.drawerContent.appendChild(formClone);
      new AddToCart(formClone);
      new SubscriptionFlow(this.drawerContent);
    }
  }
}
customElements.define("subscription-drawer", SubscriptionDrawer);

sessionStorage.setItem("firstLoadRecomm", true);
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.delegateElement = new Delegate(this);

    if (sessionStorage.getItem("firstLoadRecomm") === "true") {
      sessionStorage.setItem("firstLoadRecomm", false);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            const carouselElementNew = recommendations.querySelector(".swiper");
            const carouselElementOld = this.querySelector(".swiper");
            const productCards =
              carouselElementNew.querySelectorAll("product-card");

            carouselElementOld.parentNode.replaceChild(
              carouselElementNew,
              carouselElementOld
            );

            productCards.forEach((card) => new ProductCard(card));
            new RevolutionSwiper(carouselElementNew);
            new RevolutionAnimation(carouselElementNew, true);
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class CloseAnnBar extends HTMLElement {
  constructor() {
    super();

    const annBar = document.querySelectorAll(".announcementBar");
    const closeButton = document.querySelectorAll(".AnnouncementBar--Close");

    closeButton.forEach((closeButton) => {
      closeButton.addEventListener("click", (e) => {
        annBar.forEach((annBar) => {
          annBar.classList.add("hidden");
        });

        sessionStorage.setItem("annBarHidden", true);
      });
    });
    if (sessionStorage.getItem("annBarHidden", true)) {
      annBar.forEach((annBar) => {
        annBar.classList.add("hidden");
      });
    }
  }
}

customElements.define("button-close-section", CloseAnnBar);

class BeforeAfter extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bodyDelegate = new Delegate(document.body);

    this.imageContainer = this.element.querySelector(
      ".BeforeAfter--ImageContainer"
    );
    this.splitterLine = this.imageContainer.querySelector(
      ".BeforeAfter--SplitterLine"
    );
    this.circle = this.splitterLine.querySelector(".BeforeAfter--Circle");
    this.afterImageContainer = this.imageContainer.querySelector(
      ".BeforeAfter--AfterImageContainer"
    );
    this.afterImage = this.afterImageContainer.querySelector(
      ".BeforeAfter--AfterImage"
    );
    if (!this.afterImage)
      this.afterImage =
        this.afterImageContainer.querySelector(".placeholderSvg");

    this.afterImage.style.width = this.imageContainer.offsetWidth + "px";
    this.disableScroll = false;

    this.bindEvents();
  }

  bindEvents() {
    window.addEventListener("resize", () => {
      this.afterImage.style.width = this.imageContainer.offsetWidth + "px";
    });

    this.delegateElement.on("pointerdown", '[data-action="move"]', (e) => {
      this.isDragging = true;
      this.element.style.userSelect = "none";
      this.element.style["-webkit-user-select"] = "none";
      this.circle.style.cursor = "grabbing";
      document.body.style.cursor = "grabbing";

      this.circle.setPointerCapture(e.pointerId);
    });

    this.bodyDelegate.on("pointerup", (e) => {
      if (!this.isDragging) return;
      bodyScrollLock.clearAllBodyScrollLocks();
      this.disableScroll = false;

      this.isDragging = false;
      this.element.style.userSelect = "";
      this.element.style["-webkit-user-select"] = "";
      this.circle.style.cursor = "grab";
      document.body.style.cursor = "";

      this.circle.releasePointerCapture(e.pointerId);
    });

    this.delegateElement.on(
      "mousedown",
      '[data-action="move"]',
      this.startDragging.bind(this)
    );
    this.bodyDelegate.on("mouseup", this.stopDragging.bind(this));

    this.delegateElement.on(
      "touchstart",
      '[data-action="move"]',
      this.startDragging.bind(this)
    );
    this.bodyDelegate.on("touchend", this.stopDragging.bind(this));

    this.circleMoveListener = this.splitterCircleMove.bind(this);
    this.bodyDelegate.on("mousemove", this.circleMoveListener);
    this.bodyDelegate.on("touchmove", this.circleMoveListener);
  }

  startDragging(e) {
    this.isDragging = true;
    this.element.style.userSelect = "none";
    this.element.style["-webkit-user-select"] = "none";
    this.circle.style.cursor = "grabbing";
    document.body.style.cursor = "grabbing";

    if (e.pointerId) {
      this.circle.setPointerCapture(e.pointerId);
    }
  }

  stopDragging(e) {
    if (this.isDragging) {
      bodyScrollLock.clearAllBodyScrollLocks();
      this.disableScroll = false;

      this.isDragging = false;
      this.element.style.userSelect = "initial";
      this.element.style["-webkit-user-select"] = "";
      this.circle.style.cursor = "grab";
      document.body.style.cursor = "";

      if (e.pointerId) {
        this.circle.releasePointerCapture(e.pointerId);
      }
    }
  }

  splitterCircleMove(e) {
    if (!this.isDragging) return;

    if (e.type === "touchmove" && !this.disableScroll) {
      this.disableScroll = true;
      bodyScrollLock.disableBodyScroll(
        this.element.querySelector("[data-scrollable]"),
        bodyScrollLockOptions
      );
    }

    const mouseX = e.clientX || (e.touches && e.touches[0].clientX);
    if (!mouseX) return;

    const distance =
      this.imageContainer.offsetWidth +
      this.imageContainer.getBoundingClientRect().left -
      mouseX;

    if (distance >= 0 && distance <= this.imageContainer.offsetWidth) {
      this.afterImageContainer.style.width = distance + "px";
      this.splitterLine.style.right = distance + "px";
    }
  }
}
customElements.define("before-after", BeforeAfter);

class ThreePictures extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.swiperElement = this.element.querySelector(".swiper");
    this.swiper = new RevolutionSwiper(this.swiperElement);
  }
}
customElements.define("three-pictures", ThreePictures);

sessionStorage.setItem("firstLoadFav", true);
class FavoritesDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.sidebarDrawer = new Drawer(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.loader = this.element.querySelector(".spinningLoader");
    this.cartCount = document.querySelector(".FavoritesCount");
    this.favEmpty = document.querySelector(".TopBar--FavEmpty");
    this.favFull = document.querySelector(".TopBar--FavFull");
    if (sessionStorage.getItem("firstLoadFav") === "true") {
      sessionStorage.setItem("firstLoadFav", false);
      this.loader.classList.add("is-visible");
      this.rerenderFavorites();
    }

    this.loadRecommendations();
    this.toggleFavorites();
    this.bindEvents();
  }
  unbindEvents() {
    document.removeEventListener(
      "favorite-product:open",
      this.onFavoritesOpenListener
    );

    document.removeEventListener("click", this._addToFavoritesL);
  }
  bindEvents() {
    if (!document.body.classList.contains("listener")) {
      this.onFavoritesOpenListener = this.onFavoritesOpen.bind(this);
      this._addToFavoritesL = this.addToFavorites.bind(this);

      this.delegateBody.on(
        "click",
        '[data-action="toggle-favorites"]',
        this._addToFavoritesL
      );
      document.body.classList.add("listener");
      document.addEventListener(
        "favorite-product:open",
        this.onFavoritesOpenListener
      );
      document.addEventListener(
        "favorites:toggle",
        this.toggleFavorites.bind(this)
      );
    }
    this.calculateMaxHeightListener = this.maxHeight.bind(this);
    window.addEventListener("resize", this.calculateMaxHeightListener);
    window.onload = this.maxHeight();
  }

  onFavoritesOpen() {
    this.sidebarDrawer.isOpen = true;
  }

  maxHeight() {
    var header = this.element.querySelector(".Drawer--Header");
    if (header) {
      var headerH = header.offsetHeight;
    }

    this.element.querySelector(".FavoriteItems--Wrapper").style.height =
      window.innerHeight - headerH + "px";
  }

  getSearchQueryStrings() {
    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    // Filter out null values
    items = items.filter((id) => id !== null);
    const bucketSize = 10.0;
    const idBuckets = [];
    items.forEach((id, index) => {
      const key = Math.floor(index / bucketSize);
      if (!idBuckets[key]) {
        idBuckets[key] = [];
      }
      idBuckets[key].push(id);
    });
    return idBuckets.reduce((acc, vall) => {
      const string = vall
        .filter((id) => id !== null) // Filter out null values
        .map(function (id) {
          return "id:" + id;
        })
        .join(" OR ");

      if (string) {
        acc.push(string); // Add the string to the result array if it's not empty
      }
      return acc;
    }, []);
  }

  hideLoader(noDelay) {
    let delay;
    noDelay ? (delay = 0) : (delay = 500);
    setTimeout(() => {
      this.loader.classList.remove("is-visible");
    }, delay);
  }

  rerenderFavorites(openfavorites) {
    var _this32 = this;
    var queryStrings = this.getSearchQueryStrings();
    const promises = [];
    if (queryStrings.length == 0) this.favFull.style.opacity = 0;
    else this.favFull.style.opacity = 1;

    if (queryStrings.length == 0 && !openfavorites) {
      fetch("/?section_id=main-favorites_drawer").then(function (content) {
        content.text().then(function (html) {
          _this32.replaceContentFav(html);
          _this32.loadRecommendations();
        });
      });
    }
    queryStrings.forEach((string) => {
      promises.push(
        fetch("/search?view=favorites&type=product&q=" + string, {
          credentials: "same-origin",
          method: "GET",
        })
      );
    });
    promises.reduce(async (acc, val, index) => {
      const content = await val.then((response) => response.text());
      const container = this.element;
      if (!container.length) {
        _this32.replaceContentFav(content);
        _this32.maxHeight();
      }
    }, Promise.resolve());

    return Promise.resolve();
  }

  replaceContentFav(html) {
    var tempElement = document.createElement("div");
    tempElement.innerHTML = html;
    var cartNodeParent = this.element.querySelector(
      ".FavoritesDrawer .FavoriteItems--Wrapper"
    );

    cartNodeParent.replaceChild(
      tempElement.querySelector("#main-favorites_items"),
      this.element.querySelector("#main-favorites_items")
    );

    if (
      cartNodeParent
        .querySelector("#main-favorites_items")
        .querySelector(".favEmpty")
    ) {
      cartNodeParent
        .querySelector("#main-favorites_items")
        .classList.add("FavEmptyItems");
    }

    this.toggleFavorites();
    this.hideLoader();

    return true;
  }

  toggleFavorites() {
    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    var favorites = [
      ...document.querySelectorAll(".cardInformation--FavoritesIcon"),
      ...document.querySelectorAll(".MainProduct--FavoritesIcon"),
    ];

    if (document.body.querySelector(".emptyFavorite")) {
      if (items.length > 0) {
        document.body.querySelector(".emptyFavorite").style.display = "none";
        document.body.querySelector(".solidFavorite").style.display = "flex";
      } else {
        document.body.querySelector(".emptyFavorite").style.display = "flex";
        document.body.querySelector(".solidFavorite").style.display = "none";
      }
    }
    favorites.forEach(function (item) {
      var state = item.getAttribute("state");
      var myID = item.getAttribute("data-id");
      if (state == "not-active" && items.includes(myID)) {
        item.querySelector(".solidFavorite").style.display = "flex";
        item.querySelector(".emptyFavorite").style.display = "none";
        item.setAttribute("state", "active");
      } else if (!items.includes(myID)) {
        item.querySelector(".solidFavorite").style.display = "none";
        item.querySelector(".emptyFavorite").style.display = "flex";
        item.setAttribute("state", "not-active");
      }
    });
  }

  removeFromFavorites(productId) {
    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    items = items.filter((c) => c != productId);
    if (items.length == 0) this.loader.classList.add("is-visible");
    try {
      localStorage.setItem(
        "productFavorites",
        JSON.stringify(items.slice(0, 50))
      );
    } catch (error) {
      console.log(error);
    }
    var _this = this;
    this.toggleFavorites();

    this.rerenderFavorites().then(function () {
      new AddToCart(_this.element);
    });
  }

  loadRecommendations() {
    var _this = this;

    if (this.options["productId"] == "") {
      var url = "?section_id=helper-recommendations_favorites";
    } else {
      var url =
        window.routes.localeRootUrl +
        "/recommendations/products?section_id=helper-recommendations_favorites&product_id=" +
        this.options["productId"] +
        "&limit=10";
    }

    return fetch(url).then(function (response) {
      return response.text().then(function (content) {
        const container = document.createElement("div");
        if (container) container.innerHTML = content;

        if (container) {
          var z = container.querySelector(".Upsell__Container").innerHTML;
          var x = _this.element.querySelector(".recommSwiper .swiper-wrapper");
          if (x != null) {
            x.innerHTML = z;
          }
        }

        const swiper = new Swiper(".recommSwiper", {
          // Default parameters
          noSwipingClass: "noSwipe",
          slidesPerView: 2,
          spaceBetween: 16,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
          resistanceRatio: 0,
          scrollbar: {
            el: ".favorites-scrollbar",
          },
          breakpoints: {
            767: {
              slidesPerView: 2,
              spaceBetween: 40,
            },
          },
        });

        new AddToCart(x);
        _this.toggleFavorites();

        if (window.theme.enableAnimations) {
          new RevolutionAnimation(_this.element);
        }
      });
    });
  }

  addToFavorites(event) {
    var _this = this;
    event.preventDefault();

    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    if (items.length == 0) this.loader.classList.add("is-visible");
    var productId = event.target.parentElement.getAttribute("data-id");
    if (!productId) productId = event.target.getAttribute("data-id");

    // We check if the current product already exists, and if it does not, we add it at the start
    if (!items.includes(productId) && productId != "") {
      items.unshift(productId);
    } else {
      this.removeFromFavorites(productId, false);
      //   this._favoritesNumber();
      return;
    }
    // Then, we save the current product into the local storage, by keeping only the 50 most recent
    try {
      localStorage.setItem(
        "productFavorites",
        JSON.stringify(items.slice(0, 50))
      );
      //    this._favoritesNumber();
      this.toggleFavorites();

      this.rerenderFavorites().then(function () {
        new AddToCart(_this.element);
      });
    } catch (error) {
      // Do nothing, this may happen in Safari in incognito mode
    }
  }
}
customElements.define("favorites-drawer", FavoritesDrawer);

class UniqueSellingPoints extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    // Mobile main swiper
    this.swiper = this.element.querySelector(".usp--swiper");
    this.swiper = new RevolutionSwiper(this.swiper);

    this.btnPrev = this.element.querySelector(".usp--btnPrev");
    this.btnNext = this.element.querySelector(".usp--btnNext");

    this.btnPrev.addEventListener("click", () =>
      this.swiper.swiperElement.slidePrev(200)
    );
    this.btnNext.addEventListener("click", () =>
      this.swiper.swiperElement.slideNext(200)
    );
  }
}
customElements.define("unique-selling-points", UniqueSellingPoints);

class CollectionShowcaseButtons extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "mouseover",
      ".CollectionShowcase--button",
      this.mouseHover.bind(this)
    );

    this.delegateElement.on(
      "mouseout",
      ".CollectionShowcase--button",
      this.mouseHoverStop.bind(this)
    );
  }

  mouseHover() {
    const imageID = event.target.getAttribute("data-id");
    this.element
      .querySelector(`.CollectionShowcaseContent--image[data-id="${imageID}"]`)
      .setAttribute("data-hover", "true");
  }

  mouseHoverStop() {
    const imageID = event.target.getAttribute("data-id");
    this.element
      .querySelector(`.CollectionShowcaseContent--image[data-id="${imageID}"]`)
      .setAttribute("data-hover", "false");
  }
}
customElements.define("collection-showcase-buttons", CollectionShowcaseButtons);

class Search extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    // Find result elements
    this.resultElements = this.element.querySelectorAll(".Search--Result");
    this.filterSearchBars = this.element.querySelector(
      ".templateSearch .FilterBar"
    );
    // Find buttons to toggle between products and articles
    this.openProductBtn = this.element.querySelector("#productBtn");
    this.openArticleBtn = this.element.querySelector("#articleBtn");
    new AddToCart(this.element);

    this.bindEvents();
  }

  bindEvents() {
    // Toggle between products and articles when buttons are clicked
    this.delegateElement.on(
      "click",
      '[data-action="toggle-products"]',
      this.showProducts.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="toggle-articles"]',
      this.showArticles.bind(this)
    );
    this.delegateElement.on("filters:rerendered", () =>
      setTimeout(() => this.updateResultNumber(), 100)
    );

    this.mediaQuery = window.matchMedia("(min-width: 1025px)");
    this.mediaQuery.addEventListener(
      "change",
      this.handleBreakpointTriggered.bind(this)
    );
    document.addEventListener(
      "DOMContentLoaded",
      this.updateResultNumber.bind(this)
    );
  }

  handleBreakpointTriggered(mql) {
    if (mql.matches) {
      this.desktop = true;
      this.swipers = this.element.querySelectorAll(".swiper");
      this.swipers.forEach((swiper) => new RevolutionSwiper(swiper));
      this.init = true;
    } else {
      this.desktop = false;
      if (this.swipers && this.init)
        this.swipers.forEach((swiperEl) => swiperEl.swiper.destroy());
      this.init = false;
    }
  }

  updateResultNumber() {
    this.handleBreakpointTriggered(this.mediaQuery);
    // Find number of products and articles and display them
    const productElements = this.element.querySelectorAll(
      ".SearchProductWrapper"
    );
    const productNumber = productElements.length;
    const itemNumber = this.element.querySelector(".itemNumber");
    if (productNumber === 0) {
      this.filterSearchBars.style.display = "none";
    }
    if (itemNumber) {
      itemNumber.innerHTML = productNumber;
      if (productNumber === 0) {
        this.openProductBtn.style.display = "none";
      }
    }

    const articleElements = this.element.querySelectorAll(".BlogArticle");
    const articleNumber = articleElements.length / 2;
    const itemNumber_2 = this.element.querySelector(".itemNumber_2");
    if (itemNumber_2) {
      itemNumber_2.innerHTML = articleNumber;
      if (articleNumber === 0) {
        this.openArticleBtn.style.display = "none";
      }
    }

    if (productNumber !== 0) {
      this.showProducts();
    }
    if (productNumber === 0 && articleNumber !== 0) {
      this.showArticles();
    }
  }

  showProducts() {
    // Show product elements and hide article elements
    const productElements = this.element.querySelectorAll(
      ".SearchProductWrapper"
    );
    const productNumber = productElements.length;
    if (!productElements.length) {
      return;
    }
    const articleElements = this.element.querySelectorAll(".article-wrapper");
    articleElements.forEach((article) => {
      article.classList.add("hidden");
    });
    productElements.forEach((product) => {
      product.classList.remove("hidden");
    });
    //show filter and searh bar
    if (productNumber === 0) {
      this.filterSearchBars.style.display = "none";
    } else {
      this.filterSearchBars.style.display = "flex";
    }

    // Update button styles
    this.openProductBtn = this.element.querySelector("#productBtn");
    this.openArticleBtn = this.element.querySelector("#articleBtn");
    this.openProductBtn.classList.add("active");
    this.openArticleBtn.classList.remove("active");
  }

  showArticles() {
    //hide filters and search

    this.filterSearchBars.style.display = "none";
    // Show article elements and hide product elements
    const articleElements = this.element.querySelectorAll(".article-wrapper");
    if (!articleElements.length) {
      return;
    }
    const productElements = this.element.querySelectorAll(
      ".SearchProductWrapper"
    );
    productElements.forEach((product) => {
      product.classList.add("hidden");
    });
    articleElements.forEach((article) => {
      article.classList.remove("hidden");
    });

    // Update button styles
    this.openProductBtn = this.element.querySelector("#productBtn");
    this.openArticleBtn = this.element.querySelector("#articleBtn");
    this.openProductBtn.classList.remove("active");
    this.openArticleBtn.classList.add("active");
  }
}

customElements.define("search-component", Search);

sessionStorage.setItem("firstLoadCartPage", true);
class CartItems extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    this.updateProductCards();

    if (sessionStorage.getItem("firstLoadCartPage") === "true") {
      sessionStorage.setItem("firstLoadCartPage", false);
      if (this.options["showRecommendations"]) {
        this.loadRecommendations();
      }
    }
  }

  updateProductCards() {
    fetch(window.routes.localeRootUrl + "/cart", {
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (cartData) {
      return cartData.json();
    }).then(cartData => {
      const newArray = cartData.items.map(item => ({
        id: item.id,
        quantity: item.quantity
      }));  

      if(localStorage.getItem('oldCartState')) {
        compareArrays(JSON.parse(localStorage.getItem('oldCartState')), newArray);
      }
      localStorage.setItem('oldCartState', JSON.stringify(newArray));
    });
  }

  loadRecommendations() {
    if (this.options["productId"] == "") {
      var url = "?section_id=helper-recommendations";
    } else {
      var url =
        window.routes.localeRootUrl +
        "/recommendations/products?section_id=helper-recommendations&product_id=" +
        this.options["productId"] +
        "&limit=10";
    }

    var _this = this;
    return fetch(url).then(function (response) {
      return response
        .text()
        .then(function (content) {
          var container = document.createElement("div");
          container.innerHTML = content;
          var z = container.querySelector(".cartUpsell").innerHTML;
          var x = _this.element.querySelector(".withItemRecommendations");
          x.innerHTML = z;

          const swiper = new Swiper(".swiperUpsell", {
            // Default parameters
            noSwipingClass: "noSwipe",
            slidesPerView: 2,
            spaceBetween: 16,
            slidesOffsetAfter: 0,
            slidesOffsetBefore: 0,
            resistanceRatio: 0,
            scrollbar: {
              el: ".cart-scrollbar",
              draggable: true,
            },
            breakpoints: {
              1024: {
                slidesPerView: 4,
                spaceBetween: 40,
              },
            },
          });
        })
        .catch((e) => {
          console.error(e);
        });
    });
  }
}
customElements.define("cart-items", CartItems);

class Banner extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.carouselElement = this.element.querySelector("[data-swiper-settings]");
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.delegateElement = new Delegate(this.element);
    if (this.options["numberOfSlides"] > 1) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
      this.onImagesReady = this.createObserver.bind(this);
      this.element.addEventListener("swiper:slide-changed", this.onImagesReady);
      this.createObserver();
    } else {
      this.createObserver();
    }
  }
  createObserver() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.5,
    });
    const target = this.element;
    this.observer.observe(target);
  }
  handleIntersect(entries) {
    var _this = this;
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (_this.options["numberOfSlides"] > 1) {
          _this.changeImageQuality();
        } else {
          _this.changeImageQuality(true);
        }
        _this.observer.unobserve(_this);
      }
    });
  }
  changeImageQuality(singleItem) {
    // Get the current breakpoint.
    const breakpoint = new Responsive().getCurrentBreakpoint();
    let imageContainers;
    // Determine which element(s) to search for based on the singleItem parameter.
    if (singleItem) {
      imageContainers = Array.from(
        this.element.querySelectorAll(".Banner__ImageContainer--Swap")
      );
    } else {
      const currentIndex = this.carousel.swiperElement.activeIndex;
      const cellElement = this.carousel.swiperElement.slides[currentIndex];
      imageContainers = Array.from(
        cellElement.querySelectorAll(".Banner__ImageContainer--Swap")
      );
    }
    // If no image containers are found, return.
    if (imageContainers.length === 0) {
      return;
    }
    // Determine which image to reveal based on the current breakpoint.
    let imageToReveal;
    if (
      breakpoint === "pocket" ||
      breakpoint === "phone" ||
      breakpoint === "tablet"
    ) {
      imageToReveal = imageContainers[0].querySelector(".Banner__Image");
    } else {
      if (imageContainers.length == 2) {
        imageToReveal = imageContainers[1].querySelector(".Banner__Image");
      } else {
        imageToReveal = imageContainers[0].querySelector(".Banner__Image");
      }
    }
    // If the image to reveal is not found or has already been loaded, return.
    if (!imageToReveal || imageToReveal.dataset.loadedImage === "true") {
      return;
    }
    // Replace the image URL with a higher quality version.
    const replaceUrl = imageToReveal.dataset.src.replace(
      "{width}x",
      "width=2600"
    );
    imageToReveal.src = replaceUrl;
    imageToReveal.dataset.loadedImage = "true";
  }
}
customElements.define("banner-hero", Banner);

class PressQuote extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    if (new Responsive().matchesBreakpoint("pocket")) {
      // Mobile thumbs wrapper
      this.swiperThumbsMobileElement = this.element.querySelector(
        ".pressQuote--swiperThumbsMobile"
      );

      this.swiperMainMobileElement = this.element.querySelector(
        ".pressQuote--swiperMainMobile"
      );

      this.swiperMobLogos = this.swiperThumbsMobileElement.querySelectorAll(
        ".pressQuote--logoMobile"
      );

     

      this.duplicateAndAppendChildNodes(this.swiperMainMobileElement);
      this.duplicateAndAppendChildNodes(this.swiperThumbsMobileElement);

      this.swiperMainMobile = new RevolutionSwiper(
        this.swiperMainMobileElement
      );
      this.swiperThumbsMobile = new RevolutionSwiper(
        this.swiperThumbsMobileElement
      );

      this.onTransitionEndHandler = this.onTransitionPrevHandler.bind(this);
      this.element.addEventListener(
        "swiper:slideTransitionPrev",
        this.onTransitionPrevHandler
      );

      this.onTransitionEndHandler = this.onTransitionNextHandler.bind(this);
      this.element.addEventListener(
        "swiper:slideTransitionNext",
        this.onTransitionNextHandler
      );
    } else {
      this.swiperMainDesktopElement = this.element.querySelector(
        ".pressQuote--swiperMainDesktop"
      );

      this.swiperThumbsDesktop = this.element.querySelector(
        ".pressQuote--swiperThumbsDesktop"
      );

      this.swiperMainDesktop = new RevolutionSwiper(
        this.swiperMainDesktopElement,
        this.swiperThumbsDesktop
      );
    }

    this.bindEvents();
  }

  bindEvents() {}

  onTransitionNextHandler() {
  

    const element = event.detail.event.el;
    let elementToMove = this.swiperThumbsMobile;
    if (element.classList.contains("pressQuote--swiperThumbsMobile")) {
      elementToMove = this.swiperMainMobile;
    }
    elementToMove.swiperElement.slideNext("300", false);
  }

  onTransitionPrevHandler() {
    const element = event.detail.event.el;
    let elementToMove = this.swiperThumbsMobile;
    if (element.classList.contains("pressQuote--swiperThumbsMobile")) {
      elementToMove = this.swiperMainMobile;
    }
    elementToMove.swiperElement.slidePrev("300", false);
  }

  duplicateAndAppendChildNodes(parentElement) {
    const wrapper = parentElement.querySelector(".swiper-wrapper");
    // Clone the child nodes of the parent element
    const clonedChildNodes = Array.from(wrapper.children).map(function (node) {
      return node.cloneNode(true);
    });

   


    // Append the cloned child nodes back to the parent element
    clonedChildNodes.forEach(function (clonedNode) {
      wrapper.appendChild(clonedNode);
    });
  }
}
customElements.define("press-quote", PressQuote);

class faqSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.initObserver();
    if (new Responsive().matchesBreakpoint("pocket")) {
      this.carousel = new RevolutionSwiper(
        this.element.querySelector("[data-swiper-settings]")
      );
      window.carousel = this.carousel;
    }
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="handle-click"]',
      this.handleClick.bind(this)
    );
  }

  handleClick() {
    const allLinks = this.element.querySelectorAll(".FaqLinkList__Item");
    allLinks.forEach((item) => {
      item.classList.remove("CurrentLinkPage");
    });
    event.target.classList.add("CurrentLinkPage");
  }

  removeAllLinks() {
    const linkedOne = this.element.querySelectorAll(".CurrentLinkPage");
    if (linkedOne) {
      linkedOne.forEach((item) => {
        item.classList.remove("CurrentLinkPage");
      });
    }
  }

  initObserver() {
    window.addEventListener("scroll", this.handleScroll.bind(this));
  }

  handleScroll() {
    const faqSubheaders = this.element.querySelectorAll(".FAQSubheader");
    const faqMenuTabsWrapper = this.element.querySelector(
      ".faq--menuTabsWrapper"
    );
    if (new Responsive().matchesBreakpoint("pocket")) {
      if (faqMenuTabsWrapper) {
        const distanceFromTop = faqMenuTabsWrapper.getBoundingClientRect().top;
        const threshold = 52;
        if (distanceFromTop <= threshold && distanceFromTop > 0) {
          faqMenuTabsWrapper.style.boxShadow =
            "0px 4px 12px 0px rgba(20, 20, 20, 0.10)";
        } else {
          faqMenuTabsWrapper.style.boxShadow = "none";
        }
      }
    }
    // Adjust the threshold as needed (e.g., 100px)
    const threshold = 100;

    faqSubheaders.forEach((faqSubheader) => {
      const distanceFromTop = Math.max(
        0,
        faqSubheader.getBoundingClientRect().top
      );

      if (distanceFromTop <= threshold && distanceFromTop > 0) {
        this.removeAllLinks();
        const faqSection = faqSubheader.closest(".Faq-Section").id;
        const anchorElement = this.element.querySelectorAll(
          `a[href="#${faqSection}"]`
        );

        if (anchorElement) {
          anchorElement.forEach((item) => {
            item.classList.add("CurrentLinkPage");
          });
          if (new Responsive().matchesBreakpoint("pocket")) {
            anchorElement.forEach((item) => {
              if (!item.classList.contains("swiper-slide-active")) {
                this.carousel.swiperElement.slideTo(
                  parseInt(item.dataset.index)
                );
              }
            });
          }
        }
      }
    });
  }
}
customElements.define("faq-section", faqSection);
class OtherPagesSwiper extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.breakpoint = new Responsive().getCurrentBreakpoint();

    if (
      this.breakpoint === "phone" ||
      this.breakpoint === "tablet" ||
      this.breakpoint == "pocket"
    ) {
      this.carouselElement = this.element.querySelector(".swiper");
      this.carousel = new RevolutionSwiper(this.carouselElement);
    }
  }
}
customElements.define("small-menu-swiper", OtherPagesSwiper);

class CommentSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.whireCommentBtn = this.element.querySelector(".Comments--WhireButton");
    this.revealWrapper = this.element.querySelector(".Comments--RevealWrapper");
    this.currentPageKey = this.extractStringFromURL(window.location.href);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.articleWrapper = this.element.querySelector(
      ".Comments--ArticleWrapper"
    );
    if (this.articleWrapper)
      this.allChildren = Array.from(this.articleWrapper.children);
    this.paginationWrapper = this.element.querySelector(".Pagination-Wrapper");
    /*  this.loadMoreBtn = this.element.querySelector('.Comments--loadMoreButton'); */

    const beenHere = sessionStorage.getItem("postRequest");
    if (beenHere == this.currentPageKey) {
      this.revealWrapper.style.height = "fit-content";
      this.whireCommentBtn.style.display = "none";
    } else {
      this.bindWhireBtnListener();
    }

    this.mobile = new Responsive().matchesBreakpoint;

    const openedComments = sessionStorage.getItem("openedComments");

    this.handleAfterState();
    this.bindListeners();
  }

  bindListeners() {
    this.delegateElement.on(
      "click",
      '[data-action="load-more"]',
      this.loadMore.bind(this)
    );
    this.textArea = this.element.querySelector("#CommentForm-body");
    const formListener = this.element.querySelector("#comment_form");

    this.textAreaFunc = this.expandDynamically.bind(this);
    /*     if(this.loadMoreBtn) this.loadMoreBtn.addEventListener('click', this.updateComments.bind(this)); */
    formListener.addEventListener("submit", this.verifyForm.bind(this));
    window.addEventListener("resize", this.onResize.bind(this));
  }

  handleAfterState() {
    if (window.location.href.indexOf("#comment_form") > -1) {
      this.element
        .querySelector(".Comments--WhireButton")
        .setAttribute("aria-hidden", "true");
    }
  }

  loadMore(event, target) {
    const _this = this;
    let dataHref = target.getAttribute("data-href");

    return fetch(window.routes.localeRootUrl + dataHref, {
      credentials: "same-origin",
      method: "GET",
    }).then(function (content) {
      content.text().then(function (htmlData) {
        let html = new DOMParser().parseFromString(htmlData, "text/html");
        let newComments = html.querySelectorAll(".ArticleComments--Comment");

        let curDocument = _this.element.querySelector(".ArticleComments");
        curDocument.append(...newComments);
        let dataHref = html.querySelector("[data-href]");

        if (dataHref) {
          dataHref = dataHref.dataset.href;
          _this.element.querySelector("[data-href]").dataset.href = dataHref;
        } else {
          _this.element.querySelector(".comments--buttonFooter")?.remove();
        }
      });
    });
  }
  reduceArticles() {
    if (this.paginationWrapper) this.paginationWrapper.style.display = "none";

    if (this.articleWrapper) {
      while (this.articleWrapper.children.length > 3) {
        this.articleWrapper.removeChild(this.articleWrapper.lastChild);
      }
    }
  }

  updateComments() {
    this.loadMoreBtn.style.display = "none";

    for (const child of this.allChildren) {
      this.articleWrapper.appendChild(child);
    }

    this.paginationWrapper.style.display = "block";
    sessionStorage.setItem("openedComments", true);
  }

  verifyForm(e) {
    const requiredCheckboxes = document.querySelectorAll(
      "input.Comments--Required"
    );
    const uncheckedCheckboxes = [];

    requiredCheckboxes.forEach((checkbox) => {
      if (!checkbox.checked) {
        e.preventDefault();
        uncheckedCheckboxes.push(checkbox);
      }
    });

    if (uncheckedCheckboxes.length > 0) {
      uncheckedCheckboxes.forEach((checkbox) => {
        const errorMessageElement = checkbox.parentElement.querySelector(`label[for=${checkbox.id}]`)?.querySelector(".Comments--ErrorMessage");
        if (errorMessageElement)
          errorMessageElement.classList.add("showCommentErrorMsg");
      });
    } else {
      if (this.currentPageKey.includes("#comment_form")) {
        sessionStorage.setItem("postRequest", this.currentPageKey);
      } else {
        sessionStorage.setItem(
          "postRequest",
          this.currentPageKey + "#comment_form"
        );
      }
    }
  }

  onResize() {
    if (window.innerWidth < 1024) {
      this.textArea.addEventListener("input", this.textAreaFunc);
      this.expandDynamically();
      this.mobile = true;
    } else {
      this.textArea.removeEventListener("input", this.textAreaFunc);
      this.textArea.style.height = "128px";
      this.mobile = false;
    }
  }

  expandDynamically() {
    this.textArea.style.height = "42px";

    const scrollHeight = Math.max(
      this.textArea.scrollHeight,
      this.textArea.clientHeight
    );
    if (scrollHeight < 42) return;
    this.textArea.style.height = scrollHeight + "px";
  }

  extractStringFromURL(url) {
    const parts = url.split("/");
    return parts[parts.length - 1];
  }

  calculateFitContentHeight(elem) {
    const clone = elem.cloneNode(true);
    clone.style.visibility = "hidden";
    clone.style.height = "fit-content";
    this.element.appendChild(clone);
    const computedHeight = window.getComputedStyle(clone).height;
    this.element.removeChild(clone);

    return computedHeight;
  }

  bindWhireBtnListener() {
    this.wooshListener = this.woosh.bind(this);
    this.whireCommentBtn.addEventListener("click", this.wooshListener);
  }

  woosh(e) {
    e.preventDefault();
    this.whireCommentBtn.style.opacity = "0";
    this.whireCommentBtn.style.pointerEvents = "none";
    if (this.mobile) this.whireCommentBtn.style.marginTop = "-68px";

    const height = this.calculateFitContentHeight(this.revealWrapper);
    this.revealWrapper.style.height = height;
    setTimeout(() => {
      this.revealWrapper.style.height = "fit-content";
      this.whireCommentBtn.style.display = "none";
    }, 1000);

    this.whireCommentBtn.removeEventListener("click", this.wooshListener);
  }
}
customElements.define("comment-section", CommentSection);

class MainArticle extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.prevPageAttr = this.element
      .querySelector(".artMain--prevPage")
      .getAttribute("href");
    this.nextPageAttr = this.element
      .querySelector(".artMain--nextPage")
      .getAttribute("href");

    //Swipe detect
    const checkDirection = (
      firstX,
      lastX,
      firstY,
      lastY,
      nextPage = this.nextPageAttr,
      prevPage = this.prevPageAttr
    ) => {
      //Loads previous blog article
      if (
        lastX - firstX < -150 &&
        Math.abs(firstY - lastY) < 100 &&
        lastX < firstX &&
        prevPage
      )
        window.location.href = prevPage;

      //Loads next blog article
      if (
        lastX - firstX > 150 &&
        Math.abs(firstY - lastY) < 100 &&
        lastX > firstX &&
        nextPage
      )
        window.location.href = nextPage;
    };

    document.addEventListener("touchstart", (e) => {
      this.touchstartX = e.changedTouches[0].screenX;
      this.touchstartY = e.changedTouches[0].screenY;
    });
    document.addEventListener("touchmove", (e) => {
      this.touchendX = e.changedTouches[0].screenX;
      this.touchendY = e.changedTouches[0].screenY;
    });

    document.addEventListener("touchend", (e) => {
      checkDirection(
        this.touchstartX,
        this.touchendX,
        this.touchstartY,
        this.touchendY
      );
    });
  }
}
customElements.define("main-article", MainArticle);

class ImageText extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.checkAnimation();
  }

  checkAnimation() {
    if (!window.theme.enableAnimations) {
      const revealElements = this.element.querySelectorAll(".reveal");
      revealElements.forEach((elem) => {
        elem.classList.remove("reveal");
        elem.classList.add("zoomImgOut");
      });
    }
  }
}
customElements.define("image-text", ImageText);

class SliderAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.announcementBar = document.querySelector(".announcementBar");
    document.documentElement.style.setProperty(
      "--announcement-height-fixed",
      this.element.clientHeight + "px"
    );
    this.updateVisibleHeight();
    setTimeout(() => {
      this.updateVisibleHeight();
    }, 1500);

    if (this.options.totalBlocks < 6) {
      this.animateBig = false;
    } else {
      this.animateBig = true;
    }

    if (this.options.totalBlocks > 0 && this.options.enableAnimation) {
      this.announcementBar1 = this.element.querySelector(
        "#announcementBar--SwiperWrapperOne"
      );
      this.announcementBar2 = this.element.querySelector(
        "#announcementBar--SwiperWrapperTwo"
      );
      this.slides = this.element.querySelectorAll(".announcementBar--Slide");
      this.fadeToggle = false;
      this.firstAnimation = true;
      this.bindEvents();
    }
  }

  bindEvents() {
    const mediaQueryBig = window.matchMedia("(min-width: 1025px)");
    const mediaQuerySmall = window.matchMedia("(max-width: 1024px)");

    this.handleBigAnimation(mediaQueryBig);
    this.handleSmallAnimation(mediaQuerySmall);

    mediaQueryBig.addEventListener("change", () =>
      this.handleBigAnimation(mediaQueryBig)
    );
    mediaQuerySmall.addEventListener("change", () =>
      this.handleSmallAnimation(mediaQuerySmall)
    );

    window.addEventListener("scroll", this.updateVisibleHeight.bind(this));
    window.addEventListener("resize", this.updateVisibleHeight.bind(this));
  }
  updateVisibleHeight() {
    const rect = this.announcementBar.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate the visible height
    let visibleHeight =
      Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

    // Ensure the visibleHeight is never negative
    visibleHeight = Math.max(visibleHeight, 0);

    // Update the height of .announcementBar with the visible height
    document.documentElement.style.setProperty(
      "--announcement-height",
      `${visibleHeight}px`
    );
  }

  calculateVisibleHeight(element) {
    const rect = element.getBoundingClientRect();
    const windowHeight =
      window.innerHeight || document.documentElement.clientHeight;

    const top = Math.max(rect.top, 0);
    const bottom = Math.min(rect.bottom, windowHeight);

    return Math.max(bottom - top, 0);
  }

  toggleFade() {
    this.announcementBar2.style.display = "flex";

    if (this.fadeToggle) {
      this.announcementBar1.classList.remove("fade-in");
      this.announcementBar2.classList.add("fade-in");
    } else {
      this.announcementBar1.classList.add("fade-in");
      this.announcementBar2.classList.remove("fade-in");
    }

    this.fadeToggle = !this.fadeToggle;
  }

  fadeBig() {
    // Initially fade in the first bar
    this.announcementBar1.classList.add("fade-in");

    this.slides.forEach((slide) => (slide.style.visibility = "visible"));

    if (this.animateBig)
      this.barsTimeout = setInterval(
        () => this.toggleFade(),
        this.options.interval
      );
  }

  fadeSmall() {
    const mySlides = this.slides;
    const numSlides = mySlides.length;
    let currentSlideIndex = 0;

    const animate = () => {
      if (currentSlideIndex > 0) {
        mySlides[currentSlideIndex - 1].classList.remove("fade-in");
      }

      mySlides[currentSlideIndex].classList.add("fade-in");

      this.slidesTimeout = setTimeout(() => {
        mySlides[currentSlideIndex].classList.remove("fade-in");
        currentSlideIndex = (currentSlideIndex + 1) % numSlides;
        animate();
      }, this.options.interval);
    };

    animate();
  }

  stopFadeBig() {
    this.announcementBar1.style.display = "none";
    this.announcementBar2.style.display = "none";

    this.announcementBar1.classList.remove("fade-in");
    this.announcementBar2.classList.remove("fade-in");

    setTimeout(() => {
      this.announcementBar1.style.display = "flex";
      this.announcementBar2.style.display = "flex";
    }, 100);

    clearTimeout(this.barsTimeout);
  }

  stopFadeSmall() {
    this.slides.forEach((slide) => {
      if (slide.classList.contains("fade-in")) {
        slide.classList.remove("fade-in");
      }
    });
    clearTimeout(this.slidesTimeout);
  }

  handleBigAnimation(mql) {
    if (mql.matches) {
      if (!this.firstAnimation) {
        this.stopFadeSmall();

        this.announcementBar1.style.display = "none";
        if (this.animateBig) this.announcementBar2.style.display = "none";

        setTimeout(() => {
          this.announcementBar1.style.display = "flex";
        }, 75);

        setTimeout(() => {
          this.fadeBig();
        }, 150);
      } else {
        if (this.animateBig) this.announcementBar2.style.display = "none";
        this.fadeBig();
      }
      if (this.firstAnimation) this.firstAnimation = !this.firstAnimation;
    }
  }

  handleSmallAnimation(mql) {
    if (mql.matches) {
      if (!this.firstAnimation && this.animateBig) this.stopFadeBig();

      this.slides.forEach((slide, index) => {
        if (index !== 0) slide.style.display = "none";
      });

      setTimeout(() => {
        this.fadeSmall();

        this.slides.forEach((slide, index) => {
          if (index !== 0) slide.style.display = "flex";
        });

        if (this.firstAnimation) this.firstAnimation = !this.firstAnimation;
      }, 150);
    }
  }
}
customElements.define("slider-announcement-bar", SliderAnnouncementBar);

